define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var lpAgentConfig = require('web-agent-config/lpAgentConfig');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var LpAjaxTransport = require('lptransporter/lpajax');
    var PostmessageTransport = require('lptransporter/transports/postmessage');
    var JsonpTransport = require('lptransporter/transports/jsonp');
    var SessionDataManager = require('js2RestUtilsAsync').SessionDataManager;
    var RelManager = require('js2RestUtilsAsync').RelManager;
    var Events = require("Chronos.Events");
    var SecureUtilities = require("infra-util/SecureUtilities");

    //Init the entities scope
    var keepAliveTimeOut = 2000;
    var lpTag = window.lpTag;
    //Our public objects
    var agent = lpTag.agent = lpTag.agent || {}, chat = lpTag.chat = lpTag.chat || {};
    var voice = lpTag.voice = lpTag.voice || {}, sessionDataManager;
    var participant = lpTag.participant = lpTag.participant || {};
    var config = {}; //Contains the basic data we need for the session, account, domain, lpNumber
    var engine; //Our private pub/sub engine
    var logic; //Our logic handeling object
    var translationLayer;//Our rel managing component
    var windowLoaded = false;
    var inDebugMode = false, inResume = false, version = "1.0.0";
    var validateByAccessToken = false;
    var lpSessionVars = {
        resumeMode: "lpResumeMode",
        sessionVars: "lpAgentSessionVars",
        agent: "lpAgentRel",
        chat: "lpAgentChatRels",
        connectionState: "lpAgentConnectionState",
        useAccessToken: "lpAgentUseToken"
    };
    var lpConnectionStates = {active: "active", disabled: "disabled", notify: "notify"};
    var lpConnectionTimeout = 10000;
    var SURVEY_NOT_FOUND_ERR_CODE = 12;
    var errorConnectionTimeoutObject = {
        errorCounter: 0,
        currentConnectionState: '',
        resetKeepAliveCounter: function () {
            this.errorCounter = 0;
        },
        getTimeoutValueAndUpdateConnectionState: function () {
            if (this.errorCounter <= 1) {
                if (lpConnectionStates.active === this.currentConnectionState) {
                    updateConnectionState(lpConnectionStates.disabled);
                }
                this.errorCounter++;
                return 2000;
            }
            if (this.errorCounter >= 2 && this.errorCounter <= 3) {

                if (this.errorCounter === 2 && this.currentConnectionState !== lpConnectionStates.notify) {
                    updateConnectionState(lpConnectionStates.notify);
                }

                this.errorCounter++;
                return 4000;
            }
            if (this.errorCounter >= 4) {
                return 8000;
            }
        }
    };

    var separator = "::";
    var logTypes = {ERROR: "ERROR", INFO: "INFO", DEBUG: "DEBUG"};
    var iFrameLocation = function () {
        return inDebugMode ? "/hcp/html/lpsunco/postmessage.html" : "/hcp/html/postmessage.min.html";
    };
    var transportOrder = ["postmessage", "rest2jsonp"];//["websocket2http" , "postmessage", "rest2jsonp"];/******************Temporarily removing WebSockets until Batchelor issues are resolved ********/
    var pollVisitInfoTimeout;
    var getAgentInfoUpdates = true;
    var keepAliveMethod;
    var continuityChatSessions;

    function _setCache(requestObj) {
        // Pragma -> http/1.0
        // Cache-Control -> http/1.1
        requestObj.headers = requestObj.headers || {};
        requestObj.headers.Pragma = 'no-cache';
        requestObj.headers['Cache-Control'] = 'private, max-age=0, no-cache, no-store';
        requestObj.cache = true;

        return requestObj;
    }

    function createInstanceVariables() {
        engine = new Events({
            cloneEventData: false,
            eventBufferLimit: 50
        });
        logic = new LogicHandler();
        translationLayer = new RelManager(transportOrder);
        sessionDataManager = new SessionDataManager();
        restoreSiteVariablesFromStorage();
        setUp();
    }

    function setConfigParams(configData) {
        if (configData) {
            config.domain = configData.domain || config.domain || '';
            if (!config.domain && typeof(lpAgentConfig) !== "undefined" && lpAgentConfig.domain) {
                config.domain = lpAgentConfig.domain;
            }

            if (useInteractionPlatform()) {
                config.domain = getInteractionPlatformDomain() || config.domain;
            }

            config.lpNumber = configData.lpNumber || config.lpNumber || '';
            lpAgentConfig.lpNumber = config.lpNumber;
            config.appKey = configData.appKey || config.appKey || '';
            config.accessToken = configData.accessToken || config.accessToken || '';
            if (config.lpNumber && (config.appKey || config.accessToken) && config.domain) {
                sessionDataManager.setSessionData(lpSessionVars.sessionVars, config.lpNumber + separator + (config.appKey || config.accessToken) + separator + config.domain);
                sessionDataManager.setSessionData(lpSessionVars.useAccessToken, !!config.accessToken);
            }
        }
    }

    function getInteractionPlatformDomain() {
        var retVal;
        if (agentLEManager && agentLEManager.getLEUrlResolverApiResourcesService) {
            var interactionPlatform = agentLEManager.getLEUrlResolverApiResourcesService("InteractionPlatform");
            if (interactionPlatform.domain) {
                retVal = agentLEManager.getLEUrlResolverGetUrl(interactionPlatform.domain);
                retVal = lpUtils.removeProtocolFromURL(retVal);
            }
        }
        return retVal;
    }

    function useInteractionPlatform() {
        if (agentLEManager && agentLEManager.getAccountSettingByIdLE) {
            var interactionPlatformSource = agentLEManager.getAccountSettingByIdLE("le.site.interactionPlatformEnabled");
            return interactionPlatformSource && interactionPlatformSource.propertyValue && (interactionPlatformSource.propertyValue.value === "true" || interactionPlatformSource.propertyValue.value === "transparent");
        }
    }

    function setUp() {

        agent.onLog(function (data) {
            if (lpTag && lpTag.log) {
                var type = data.type;
                var errorMessage = {};
                for (var key in data) {
                    if (data.hasOwnProperty(key) && data[key] !== data) {
                        if (typeof data[key] === 'object') {
                            try {
                                errorMessage[key] = JSON.stringify(data[key]);
                            } catch (err) {
                                errorMessage[key] = key + "-recursive object";
                            }
                        } else if (typeof data[key] === 'function') {
                            errorMessage[key] = 'func:' + key;
                        } else {
                            errorMessage[key] = data[key];
                        }
                    }
                }
                try {
                    errorMessage = JSON.stringify(errorMessage);
                } catch (err) {
                    errorMessage = "data in log is recursive";
                }
                lpTag.log(errorMessage, type, 'onLog');
            }
        });

        agent.onLogInAgent(function (data) {
            if (!data.error) {
                logic.setKeepAlive(true);
                setTimeout(logic.keepAlive, 500);
            }
            sessionDataManager.removeSessionData(lpSessionVars.chat);
        });

        agent.onAcceptChat(onAcceptOrOpenSpectateChat);

        chat.onOpenSpectated(onAcceptOrOpenSpectateChat);

        chat.onChatState(function (data) {
            if (!data.error && data.state) {
                if (data.state === "ended") {
                    logic.updateVisitURI(data.chatId); // Added one last call to this resource to make sure the inactive chat will be as updated as possible
                    logic.updateChatSession(data.chatId); // Added one last call to this resource to make sure the inactive chat will be as updated as possible
                    logic.stopChatPolling(data.chatId);
                    logic.stopVisitPolling(data.chatId); // TODO: When we will have more then one connection channel we will need to add logic here regarding the whole engagement.
                } else if (data.state === "transferred") {
                    logic.removeChatFromQueue(data.chatId);
                }
            }
        });

        chat.onTransferChat(function (data) {
            if (!data.error) {
                logic.removeChatFromQueue(data.chatId);
            }
        });

        agent.onLogOutAgent(function (data) {
            if (!data.error) {
                logic.setKeepAlive(false);
                logic.sessionEnded();
            }
        });

        if (typeof(lpAgentConfig) !== "undefined" && lpAgentConfig) {
            setConfigParams(lpAgentConfig);
            if (typeof lpAgentConfig.debug === 'boolean') {
                agent.setDebugMode(lpAgentConfig.debug);
            }
            pollVisitInfoTimeout = lpAgentConfig.pollVisitInfoTimeout ? lpAgentConfig.pollVisitInfoTimeout : 0;
            //Set up call backs from config file only for 'onSOMETHING' events
            for (var key in lpAgentConfig) {
                if (lpAgentConfig.hasOwnProperty(key)) {
                    if (String(key).indexOf('on') === 0) {
                        if (agent.hasOwnProperty(key)) {
                            agent[key](lpAgentConfig[key]);
                        } else if (chat.hasOwnProperty(key)) {
                            chat[key](lpAgentConfig[key]);
                        } else if (voice.hasOwnProperty(key)) {
                            voice[key](lpAgentConfig[key]);
                        } else if (participant.hasOwnProperty(key)) {
                            participant[key](lpAgentConfig[key]);
                        }
                    }
                }
            }
        }

        if (getAgentInfoUpdates) {
            keepAliveMethod = getAgentSessionData;
        } else {
            keepAliveMethod = getIncomingRequests;
        }

        if (!lpAgentConfig.lazyInitialization) {
            if (document.readyState === "complete") {//For load event
                windowLoaded = true;
            } else {
                if (window.addEventListener) {
                    window.addEventListener("load", loaded, false);
                } else {
                    window.attachEvent("onload", loaded);
                }
            }
        }
    }

    function onAcceptOrOpenSpectateChat(data) {
        if (!data.error) {
            getVisitURI({
                chatId: data.chatInfo.chatId, visitorId: data.visitorInfo.visitorId,
                success: function (successData) {
                    var visitorId = data.visitorInfo.visitorId;
                    var chatId = data.chatInfo.chatId;
                    var visitSessionKey = successData.body.visitId.visitSessionKey;
                    engine.publish({
                        eventName: 'onVisitSessionKey',
                        data: {visitorId: visitorId, chatId: chatId, visitSessionKey: visitSessionKey}
                    });
                    if (!data.visitorInfo.shark) { // Only for AppServer visitors
                        var lastPageIndex = getLastPageIndex(successData.body.visitId);
                        logic.addVisitURIRequestToQueue(visitorId, visitSessionKey, lastPageIndex);
                    }
                }
            });
        }
    }

    //Function to notify agent has loaded along with Page
    function loaded() {
        var connectionState;
        if (sessionDataManager) {
            connectionState = sessionDataManager.getSessionData(lpSessionVars.connectionState);

            if (inResume) {
                resumeSession(connectionState);
            }
        }
        engine.publish({
            eventName: 'onLoad',
            data: {
                API: "Agent API SDK Loaded",
                version: version,
                status: (inResume ? "loggedIn" : "loggedOff"),
                statusId: 0,
                connectionState: connectionState
            }
        });
        if (!windowLoaded) {
            if (window.removeEventListener) {
                window.removeEventListener("load", loaded, false);
            } else {
                window.detachEvent("onload", loaded);
            }
        }
        windowLoaded = true;
    }

    // This function will resume the agent session
    function resumeSession(connectionState) {
        //  if connection was flagged as disabled before trying to resume, try to reconnect first
        if (connectionState === lpConnectionStates.disabled) {
            reconnect(lpConnectionTimeout, restoreAgentState);
            // This prevents us from autoResuming in the LiveEngage project to prevent race conditions in the application load
            // This way we will call the resume session only when we know we are ready.
        } else {
            restoreAgentState();
        }
    }

    // This function will resume the agent session given the fact the connection is valid
    function restoreAgentState() {

        // notify connection active
        updateConnectionState(lpConnectionStates.active);

        // restore agent and chat rels from storage
        restoreAgentSessionRelFromStorage();

        // request agent session data and chats from the server
        getInitialAgentSessionData();

        function restoreAgentSessionRelFromStorage() {
            var agentSession = sessionDataManager.getSessionData(lpSessionVars.agent);
            translationLayer.addRels({
                link: [
                    {rel: 'location', href: agentSession}
                ]
            }, {type: "agent"});
        }
    }

    // This function will try to validate the connection with the server.
    // The function will use the "init" resource and act upon success/error of the request.
    // The reason it was selected is since it is the least harmful request to perform when the server is restarting.
    // When successful the successCallback provided will be executed.
    function reconnect(delayTimeout, successCallback) {
        checkConnection({
            success: function (data) {
                runCallback(successCallback, {context: null}, data);
            },
            error: function () {

                setTimeout(function () {
                    reconnect(delayTimeout, successCallback);
                }, errorConnectionTimeoutObject.getTimeoutValueAndUpdateConnectionState());
            }
        });
    }

    function checkConnection(reqObj) {
        var requestObj = translationLayer.buildRequestObj({rel: '', data: reqObj});
        requestObj.retries = 0;
        requestObj.timeout = lpConnectionTimeout;
        requestObj.success = function (data) {
            runSuccessCallback(reqObj, data);
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Check Connection request was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    }

    // This function will restore from the storage manager essential session data.
    function restoreSiteVariablesFromStorage() {
        var configSettings = sessionDataManager.getSessionData(lpSessionVars.sessionVars);
        var configVars = configSettings ? configSettings.split(separator) : [];
        if (configVars.length === 3) {
            var token = configVars[1];
            var setupObj = {lpNumber: configVars[0], domain: configVars[2]};
            if (sessionDataManager.getSessionData(lpSessionVars.useAccessToken)) {
                setupObj.accessToken = token;
            } else {
                setupObj.appKey = token;
            }
            setConfigParams(setupObj);
            translationLayer.setData(setupObj);
            setupObj = null;
        } else {//Clears all our session data since it's useless without the config data
            sessionDataManager.clearSessionData(lpSessionVars);
            return;
        }
        inResume = sessionDataManager.getSessionData(lpSessionVars.resumeMode);
    }

    // This method will publish the new connection state and store it to the data storage
    function updateConnectionState(state) {
        if (state) {
            errorConnectionTimeoutObject.currentConnectionState = state;
            engine.publish({
                eventName: "onConnectionState",
                appName: "keepSessionAlive",
                data: {connectionState: state}
            });
            sessionDataManager.setSessionData(lpSessionVars.connectionState, state);
        }
    }

    ////
    // This function checks if the error we received indicates a lost connection to the appServer.
    // Should act upon appServer restart/busy/lost connectivity/same agent login... etc
    // @param errorData
    ///
    function checkConnectionError(errorData) {
        if (errorData) {
            var diagnostics = window.lpTag.WebAgent.logicController && window.lpTag.WebAgent.logicController.diagnostics;
            var shouldLogExtra = diagnostics && diagnostics.isKeyActive(diagnostics.keys.keepAliveDenverError);
                if (errorData.responseCode) {
                errorData.error = errorData.body && errorData.body.error ? errorData.body.error : errorData.error;
                var errorBody = errorData.body || errorData;
                switch (errorData.responseCode) {
                    case 401 : // Session is over, token is probably not valid anymore
                        if (errorData && errorData.error && errorData.error.internalCode === 10) { // cassandra connectivity issues
                            logic.postponeKeepAlive(lpConnectionTimeout); // connectivity issues
                        } else {
                            engine.publish({eventName: 'onLogOutAgent', data: getLoggedOffData(errorData)});
                        }
                        if (shouldLogExtra) {
                            log(logTypes.ERROR, {
                                logMessage: '401 error response code on Check Connection',
                                response: errorData.responseCode,
                                internalCode: errorData.error && errorData.error.internalCode
                            });
                        }
                        break;
                    case 403 :
                        if (errorData && errorData.error && errorData.error.internalCode === 11) { // account expired/disabled
                            engine.publish({eventName: 'onLogOutAgent', data: getLoggedOffData(errorData)});
                        } else {
                            logic.postponeKeepAlive(lpConnectionTimeout); // connectivity issues
                        }
                        if (shouldLogExtra) {
                            log(logTypes.ERROR, {
                                logMessage: '403 error response code on Check Connection',
                                response: errorData.responseCode,
                                internalCode: errorData.error && errorData.error.internalCode
                            });
                        }
                        break;
                    case 404 :
                        if (errorData && errorData.error && errorData.error.internalCode === 12) { // session over/operator disabled
                            engine.publish({eventName: 'onLogOutAgent', data: getLoggedOffData(errorData)});
                        } else {
                            logic.postponeKeepAlive(lpConnectionTimeout); // connectivity issues
                        }
                        if (shouldLogExtra) {
                            log(logTypes.ERROR, {
                                logMessage: '404 error response code on Check Connection',
                                response: errorData.responseCode,
                                internalCode: errorData.error && errorData.error.internalCode
                            });
                        }
                        break;
                    case 500 : // service error
                        if ((errorBody && errorBody.error && errorBody.error.internalCode && errorBody.error.internalCode === 20) ||
                            (errorData.internalCode && errorData.internalCode >= 12000)) {
                            logic.postponeKeepAlive(lpConnectionTimeout);
                        }
                        if (shouldLogExtra) {
                            log(logTypes.ERROR, {
                                logMessage: '500 error response code on Check Connection',
                                response: errorData.responseCode,
                                internalCode: errorData.error && errorData.error.internalCode
                            });
                        }
                        break;
                    case 503 :
                        if (errorBody && errorBody.error && errorBody.error.internalCode) {
                            updateConnectionState(lpConnectionStates.disabled);
                            var reconnectDelayTimeout = errorBody.error.internalCode === 27 ? lpConnectionTimeout : null; // We want to delay the reconnection method only in the case HA restart, hence internal code 27
                            logic.postponeKeepAlive(lpConnectionTimeout, reconnectDelayTimeout);
                        }
                        if (shouldLogExtra) {
                            log(logTypes.ERROR, {
                                logMessage: '503 error response code on Check Connection',
                                response: errorData.responseCode,
                                internalCode: errorData.error && errorData.error.internalCode
                            });
                        }
                        break;
                    default :
                        log(logTypes.ERROR, {
                            logMessage: "Unknown error response code on Check Connection Error",
                            response: errorData.responseCode,
                            internalCode: errorData.error && errorData.error.internalCode
                        });
                        logic.postponeKeepAlive(lpConnectionTimeout, lpConnectionTimeout);
                        break;
                }
            } else if (errorData.ResultSet && errorData.ResultSet.lpErrorCode === 27) { // server unavailable
                logic.postponeKeepAlive(lpConnectionTimeout);
                if (shouldLogExtra) {
                    log(logTypes.ERROR, {
                        logMessage: 'lpErrorCode 27 error response code on Check Connection (server unavailable)',
                        response: errorData.responseCode,
                        internalCode: errorData.error && errorData.error.internalCode
                    });
                }
            }
        }
    }

    function getLoggedOffData(errorData) {
        return {
            error: {
                status: 'loggedOff',
                statusId: parseInt(getPropFromError(errorData, "internalCode"), 10) || null,
                message: getPropFromError(errorData, "message")
            },
            status: 'loggedOff'
        };
    }

    function delayUpdateState(state, delay) {
        setTimeout(function () {
            updateConnectionState(state);
        }, delay);
    }

    function addToEventEngine(eventName, callBack, appName, context) {
        if (!engine) {
            return false;
        }

        var eventInfo = {
            eventName: eventName,
            appName: appName || "",
            aSync: false,
            func: callBack,
            context: (context || null)
        };
        return engine.register(eventInfo);
    }

    function unbindFromEvents(eventName, appName, callBack, context) {
        if (!engine) {
            return false;
        }

        if (typeof eventName === 'function') {
            callBack = eventName;
            eventName = "";
        } else if (typeof eventName === 'object') {
            context = eventName;
            eventName = "";
        }

        var eventInfo = {
            eventName: eventName,
            appName: appName || "",
            func: callBack || null,
            context: (context || null)
        };
        return engine.unbind(eventInfo);
    }

    function LogicHandler() {
        var keepAliveId, keepSessionAlive = false;
        var chats = {};
        var chatIdsBySession = {};
        var endedChats = {};
        var visits = {};
        var pollVisitInfoTimeoutCounter;
        var agentInfo = null;

        function clearPreviousRequest() {
            if (keepAliveId) {
                clearTimeout(keepAliveId);
                keepAliveId = null;
            }
        }

        function keepSessionLive() {
            clearPreviousRequest();
            if (keepSessionAlive) {
                keepAliveMethod({
                    success: function () {
                        errorConnectionTimeoutObject.resetKeepAliveCounter();
                        log(logTypes.DEBUG, {logMessage: "Success on Keep Session Alive"});
                        var chatsObj = createChatsObj();
                        if (chatsObj.hasChats) {
                            getChatsData(chatsObj);
                        } else {
                            triggerNextKeepSessionAlive();
                        }
                        chatsObj = null;
                        if (pollVisitInfoTimeout) {
                            if (typeof pollVisitInfoTimeoutCounter === "undefined") {
                                pollVisitInfoTimeoutCounter = pollVisitInfoTimeout;
                            }
                            if (pollVisitInfoTimeoutCounter <= 0) {
                                var visitsObj = createVisitsObj();
                                if (visitsObj.hasVisits) {
                                    getVisitURIs(visitsObj);
                                }
                                visitsObj = null;
                                pollVisitInfoTimeoutCounter = pollVisitInfoTimeout;
                            }
                            pollVisitInfoTimeoutCounter -= keepAliveTimeOut;
                        }
                    },
                    error: function (errorData) {
                        checkConnectionError(errorData);
                    }
                });
            }
        }

        function addChatsObjCallbacks(object) {
            object.success = triggerNextKeepSessionAlive;
            object.error = triggerNextKeepSessionAlive;
        }

        function triggerNextKeepSessionAlive() {
            if (!keepAliveId) {
                keepAliveId = setTimeout(keepSessionLive, keepAliveTimeOut);
            }
        }

        function createChatsObj(singleChatId) {
            var chatsObj = {chatSessionKeys: "", fromEventIds: ""};
            if (singleChatId) { // create object for single chat
                updateChatInObj(singleChatId);
            } else { // create object for all chats
                for (var chatId in chats) {
                    updateChatInObj(chatId);
                }
            }
            chatsObj.chatSessionKeys = chatsObj.chatSessionKeys.substr(0, chatsObj.chatSessionKeys.length - 1);
            chatsObj.fromEventIds = chatsObj.fromEventIds.substr(0, chatsObj.fromEventIds.length - 1);
            chatsObj.hasChats = !!chatsObj.chatSessionKeys;
            addChatsObjCallbacks(chatsObj);
            return chatsObj;

            function updateChatInObj(chatId) {
                if (chats.hasOwnProperty(chatId) && chats[chatId].polling) {
                    chatsObj.chatSessionKeys += chats[chatId].chatSessionKey + ",";
                    chatsObj.fromEventIds += chats[chatId].fromEventId + ",";
                }
            }
        }

        function createVisitsObj(visitorId) {
            var visitsObj = {visitSessionKeys: "", fromPageIndexes: ""};
            if (visitorId) {
                addVisitorToObject(visitorId);
            } else {
                for (visitorId in visits) {
                    addVisitorToObject(visitorId);
                }
            }
            visitsObj.visitSessionKeys = visitsObj.visitSessionKeys.substr(0, visitsObj.visitSessionKeys.length - 1);
            visitsObj.fromPageIndexes = visitsObj.fromPageIndexes.substr(0, visitsObj.fromPageIndexes.length - 1);
            visitsObj.hasVisits = !!visitsObj.visitSessionKeys;
            return visitsObj;

            function addVisitorToObject(visitorId) {
                if (visits.hasOwnProperty(visitorId) && visits[visitorId].polling) {
                    visitsObj.visitSessionKeys += visits[visitorId].visitSessionKey + ",";
                    visitsObj.fromPageIndexes += visits[visitorId].fromPageIndex + ",";
                }
            }
        }

        /**
         * The purpose of this function is to identify if the visitor is a shark visitor.
         * if this is the case, it will set the visitor ID to be the shark ID and will map
         * both ID's to each other for future reference.
         * @param visitorData
         */
        this.fixVisitorId = function (visitorData) {
            visitorData.appServerVisitorId = visitorData.visitorId;
            if (visitorData.sharkVisitorId) {
                visitorData.shark = true;
                visitorData.visitorId = visitorData.sharkVisitorId;
                delete visitorData.sharkVisitorId;
            }
        };

        // This function will postpone the keepAlive method as long as there is no connection with a delayTime interval of checks
        this.postponeKeepAlive = function (delayTimeout, reconnectDelayTimeout) {
            if (reconnectDelayTimeout) {
                delayUpdateState(lpConnectionStates.notify, 5000);
            }
            if (keepSessionAlive) {
                keepSessionAlive = false;
                sessionDataManager.setSessionData(lpSessionVars.connectionState, lpConnectionStates.disabled);
                setTimeout(function () {
                    reconnect(delayTimeout, function () {
                        keepSessionAlive = true;
                        keepSessionLive();
                    });
                }, reconnectDelayTimeout || 0);
            }
        };

        this.setLastEventId = function (chatId, lastEventId) {
            chats[chatId].fromEventId = chats[chatId].fromEventId <= lastEventId ? Number(lastEventId) + 1 : chats[chatId].fromEventId;
        };

        this.setLastPageIndex = function (visitId, lastPageIndex) {
            if (visits[visitId]) {
                visits[visitId].fromPageIndex = visits[visitId].fromPageIndex <= lastPageIndex ? Number(lastPageIndex) + 1 : visits[visitId].fromPageIndex;
            }
        };

        this.setKeepAlive = function (keepSession) {
            clearPreviousRequest();
            keepSessionAlive = keepSession;
            sessionDataManager.setSessionData(lpSessionVars.resumeMode, keepSession);
        };

        this.getVisitorVisitSessionId = function (visitorId, forCollab) {
            var visitorSessionId = visits && visits[visitorId] ? visits[visitorId].visitSessionKey : null;
            if (forCollab && visitorSessionId) {
                var regExVisit = /^[hH]{1}\d+[kK]{1}/gi;
                visitorSessionId = visitorSessionId.replace(regExVisit, "");
            }
            return visitorSessionId;
        };

        this.keepAlive = function () {
            keepSessionLive();
        };

        this.addChatEventsRequestToQueue = function (chatId, chatSessionKey, visitorId, fromEventId, url, resumeChatOnReload) {
            if (visits[visitorId]) { // checking if we are already in an engagement with this visitor
                if (visits[visitorId].chat) { // checking if we are already in an chat with this visitor
                    sessionDataManager.removePartialSessionData(lpSessionVars.chat, visits[visitorId].chat.sessionUri); // removing the current chat rel from the sessionDataManager
                }
            } else {
                visits[visitorId] = {};
            }
            visits[visitorId].chat = {
                sessionUri: url
            };
            chats[chatId] = {
                chatId: chatId,
                chatSessionKey: chatSessionKey,
                visitorId: visitorId,
                fromEventId: fromEventId,
                sessionUri: url,
                polling: true
            };
            chatIdsBySession[chatSessionKey] = chatId;
            if (resumeChatOnReload) {
                sessionDataManager.appendToSessionData(lpSessionVars.chat, url);
            }
        };

        this.resumeChatOnReload = function (chatId) {
            if (chats[chatId]) {
                sessionDataManager.appendToSessionData(lpSessionVars.chat, chats[chatId].sessionUri);
            }
        };

        this.addVisitURIRequestToQueue = function (visitorId, visitSessionKey, lastPageIndex) {
            visits[visitorId] = visits[visitorId] || {};
            var firstTimeAdded = typeof visits[visitorId].visitSessionKey === "undefined";
            var splitSession = !firstTimeAdded && visits[visitorId].visitSessionKey !== visitSessionKey;
            visits[visitorId].visitSessionKey = visitSessionKey;
            if (splitSession || (firstTimeAdded && visits[visitorId].polling !== false)) {
                visits[visitorId].polling = true;
            }
            var nextPageIndex = lastPageIndex ? Number(lastPageIndex) + 1 : 0;
            visits[visitorId].fromPageIndex = nextPageIndex;
        };

        this.stopKeepAlive = function () {
            keepSessionAlive = false;
        };

        this.setAgentTyping = function (chatId, typing) {
            if (chats[chatId]) {
                chats[chatId].typing = typing;
            }
        };

        this.getAgentTypingStatus = function (chatId) {
            if (chats[chatId]) {
                return chats[chatId].typing;
            }
            return false;
        };

        this.setAgentInfo = function (data) {
            agentInfo = data;
        };

        this.getAgentInfo = function () {
            return agentInfo;
        };

        this.updateVisitURI = function (chatId) {
            getVisitURIs(createVisitsObj(chats[chatId].visitorId));
        };

        this.updateChatSession = function (chatId) {
            var chatsObj = createChatsObj(chatId);
            if (chatsObj.hasChats) {
                getChatsData(chatsObj);
            }
        };

        this.stopChatPolling = function (chatId) {
            if (chats[chatId]) {
                chats[chatId].polling = false;
                return true;
            }
            return false;
        };

        this.resumeChatPolling = function (chatId) {
            if (chats[chatId]) {
                chats[chatId].polling = true;
                return true;
            }
            return false;
        };

        this.stopVisitPolling = function (chatId) {
            if (chats[chatId]) {
                visits[chats[chatId].visitorId].polling = false;
            }
        };

        this.removeChatFromQueue = function (chatId) {
            if (chats[chatId]) {
                sessionDataManager.removePartialSessionData(lpSessionVars.chat, chats[chatId].sessionUri);
                endedChats[chatId] = chatId;
                visits[chats[chatId].visitorId] = null; // TODO: This should be modified when the visit will include more than just Chat channel
                delete visits[chats[chatId].visitorId];
                chatIdsBySession[chats[chatId]] = null;
                delete chatIdsBySession[chats[chatId]];
                chats[chatId] = null;
                delete chats[chatId];
                return true;
            }
            return false;
        };

        this.getChatIdBySessionKey = function (chatSessionKey) {
            if (chatIdsBySession[chatSessionKey]) {
                return chatIdsBySession[chatSessionKey];
            }
        };

        this.clearChatData = function (chatId) {
            if (endedChats[chatId]) {
                translationLayer.removeRels({type: "chat", id: chatId});
                endedChats[chatId] = null;
                delete endedChats[chatId];
                return true;
            }
            return false;
        };

        this.sessionEnded = function () {
            for (var key in chats) {
                if (chats.hasOwnProperty(key)) {
                    this.removeChatFromQueue(key);
                }
            }
            translationLayer.clearData();
            config = {};
            logic.setAgentInfo(null);
            sessionDataManager.clearSessionData(lpSessionVars);
        };

        this.isActiveChat = function (chatId) {
            return !(!chats[chatId]);
        };
    }

    function logAndReturnError(errorObj, originalRequest, sentRequest, response) {
        log(logTypes.ERROR, {
            error: errorObj,
            originalRequest: originalRequest,
            sentRequest: sentRequest,
            response: response
        });
        originalRequest = null;
        sentRequest = null;
        response = null;
        return errorObj;
    }

    function log(logType, logDataObj) {
        var logObj = {eventName: 'onLog'};
        if (logType !== logTypes.ERROR && !inDebugMode) {
            logObj = null;
            return;
        }
        if (logType && typeof logType === 'string') {//Check if a log type was supplied, allows listening to error,info or all
            logObj.appName = logType;
            logDataObj = logDataObj || {};
            logDataObj.type = logType;
        } else if (typeof logType === 'object') {
            logDataObj = logType;
        }

        logObj.data = _.clone(logDataObj, true);

        if (logObj.data.sentRequest &&
            logObj.data.sentRequest.headers &&
            logObj.data.sentRequest.headers.AUTHORIZATION) {

            logObj.data.sentRequest.headers.AUTHORIZATION = "***omitted***";
        }

        engine.publish(logObj);
        logObj = null;
    }

    //Method for running direct error callbacks supplied to functions
    function runErrorCallback(requestObj, data) {
        if (requestObj && requestObj.error) {
            runCallback(requestObj.error, requestObj, data);
        }
        data = null;
        requestObj = null;
    }

    //Method for running direct success callbacks supplied to functions
    function runSuccessCallback(requestObj, data) {
        if (requestObj && requestObj.success) {
            runCallback(requestObj.success, requestObj, data);
        }
        data = null;
        requestObj = null;
    }

    //Generic method for running callbacks
    function runCallback(callback, requestObj, data) {
        if (callback && typeof callback === 'function') {
            try {
                callback.apply(requestObj.context || requestObj, [data]);
            } catch (err) {
                log(logTypes.ERROR, {
                    originalRequest: requestObj,
                    response: data,
                    error: "Failed to run callback",
                    thrownError: err
                });
                // REMOVE_BEFORE_PRODUCTION_START
                if (lpAgentConfig && lpAgentConfig.throwExceptions) {
                    throw err;
                }
                // REMOVE_BEFORE_PRODUCTION_END
            }
        }
        callback = null;
        data = null;
        requestObj = null;
    }

    //Sets debug mode for sending logs to server and appending all logs to events transcript
    agent.setDebugMode = function (debug) {
        if (typeof debug === 'boolean') {
            inDebugMode = debug;
        }
    };

    agent.getURI = function(relName, typeObject) {
        return translationLayer.getURI(relName, typeObject);
    };

    /**
     * Returns the internal error or a generic error we generate
     * @param errorData
     * @param message
     * @param reqObj
     * @param extraParams
     * @return {*}
     */
    function getErrorData(errorData, message, reqObj, extraParams) {
        errorData = errorData && errorData.body ? errorData.body : {
            error: {
                message: message,
                time: new Date(),
                originalRequest: reqObj
            }
        };
        errorData = errorData.error ? errorData : {error: errorData};
        for (var key in extraParams) {
            if (extraParams.hasOwnProperty(key) && !errorData[key]) {
                errorData[key] = extraParams[key];
            }
        }
        extraParams = null;
        return errorData;
    }

    /////
    // @param   reqObj : {
    //              lpNumber : LP account number,
    //          }
    // @return  success : {
    //              init : true
    //          }
    // @return  fail : {
    //              init : false,
    //              error: {
    //                  message : 'unable to resolve site domain'
    //              }
    //          }
    ///
    function getCSDSDomain(reqObj) {
        var preRequest = {site: reqObj.lpNumber};
        preRequest.success = function (data) {
            reqObj.domain = data.domain;
            agent.init(reqObj);
        };
        preRequest.error = function (data) {
            logAndReturnError({error: 'unable to resolve site domain'}, reqObj, "", data);
            runErrorCallback(reqObj);
        };
        agent.getSiteDomain(preRequest);
    }

    agent.loadAgentWithToken = function (accessToken) {
        if (accessToken && config.accessToken !== accessToken) {
            inResume = false;
        }
        loaded();
    };

    agent.isInResume = function () {
        return inResume;
    };

    agent.postInitialization = function () {
        keepContinuityForChats();
    };

    agent.getSiteDomain = function (requestObj) {
        if (typeof requestObj.success !== 'function' || !requestObj.site) {
            return logAndReturnError({error: 'missing callback or site - cannot lookup domain'}, "", "", "");
        }
        var baseUrl = "https://api.liveperson.net/csdr/account/";
        var urlSuffix = "/service/adminArea/baseURI.lpCsds?version=1.0";
        var preRequest = {url: baseUrl + requestObj.site + urlSuffix};
        preRequest.success = function (data) {
            var domain;
            log(logTypes.DEBUG, {originalRequest: {site: requestObj.site}, sentRequest: preRequest, response: data});
            if (data && data.ResultSet && data.ResultSet.lpData) {
                var results = data.ResultSet.lpData;
                for (var i = 0; i < results.length; i++) {
                    if (!domain && results[i].lpServer) {
                        domain = results[i].lpServer;
                    }
                }
            }
            preRequest = null;
            if (domain) {
                runSuccessCallback(requestObj, {domain: domain, site: requestObj.site});
            } else {
                runErrorCallback(requestObj, {
                    error: "unable to resolve site domain",
                    response: data,
                    site: requestObj.site
                });
            }
        };
        preRequest.error = preRequest.success;
        log(logTypes.DEBUG, {
            originalRequest: {site: requestObj.site},
            sentRequest: preRequest,
            logMessage: "Get Site Domain was sent"
        });


        return JsonpTransport.issueCall(preRequest);
    };

    /////
    // @param   reqObj : {
    //              appKey : application key,
    //              lpNumber : LP account number,
    //              domain : domain address
    //          }
    // @return  success : {
    //              init : true
    //          }
    // @return  fail : {
    //              init : false,
    //              error: {
    //                  message : 'unable to initiate session'
    //              }
    //          }
    ///
    agent.init = function (reqObj) {
        setConfigParams(reqObj);
        reqObj.lpNumber = config.lpNumber;
        if (!config.accessToken) {
            reqObj.appKey = config.appKey;
        }
        reqObj.domain = config.domain;
        reqObj.accessToken = config.accessToken;

        validateByAccessToken = !!config.accessToken;

        if (!reqObj.lpNumber || (!reqObj.appKey && !reqObj.accessToken)) {
            return logAndReturnError({error: 'missing siteconfiguration data, cannot init'}, reqObj, "", "");
        }
        if (!reqObj.domain) {
            getCSDSDomain(reqObj);
            return false;
        }
        translationLayer.setData(reqObj);

        if (reqObj.accessToken) {
            reqObj.accessToken = null;
            delete reqObj.accessToken;
        }

        var requestObj = translationLayer.buildRequestObj({rel: '', data: reqObj});

        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Agent init"
            });
            if (data) {
                translationLayer.addRels(data.body.account, {type: 'agent'});
                engine.publish({
                    eventName: 'onInit',
                    data: {account: reqObj.lpNumber, domain: reqObj.domain, init: true}
                });
            }
            runSuccessCallback(reqObj, {});
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Agent init"
            });
            errorData = getErrorData(errorData, 'unable to initiate session', reqObj, {init: false});
            engine.publish({eventName: 'onInit', data: errorData});
            translationLayer.clearData();//Init fails so we don't save site data
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "Agent init was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @param   reqObj : {
    //              userName : user name,
    //              password : 1
    //          }
    // @return  success : {
    //              status: 'loggedIn',
    //              chatAvailability: 'Away'
    //          }
    // @return  fail : {
    //              error: 'Unable to login to server'
    //          }
    ///
    agent.logInAgent = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, reqObj, "", "");
        }
        if (!validateByAccessToken && (!reqObj.userName || !reqObj.password)) {
            return logAndReturnError({error: 'No username/password was submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'agent-session',
            type: 'agent',
            needAuth: true,
            requestType: 'POST',
            data: {loginData: reqObj}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'loginAgent - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on logInAgent"
            });
            if (data && (data.responseCode === 201)) {
                translationLayer.addRels(data.body.agentSessionLocation, {type: 'agent'});
                getInitialAgentSessionData();
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on logInAgent"
            });
            errorData = getErrorData(errorData, 'error logging in agent', reqObj, getLoggedOffData(errorData));
            engine.publish({eventName: 'onLogInAgent', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
            engine.publish({eventName: 'onLogOutAgent', data: getLoggedOffData(errorData)});
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "logInAgent was sent"});
        return PostmessageTransport.issueCall(requestObj);
    };

    /////
    // Adding private rels which are not published via the regular operation.
    // Those rels are manually added to the body before transferring to the translation layer
    // Currently we are adding the pre-defined-content to the agent session.
    ///
    function addPrivateRels(lookupRel, typeObj, relsToAdd) {
        var self = translationLayer.getURI(lookupRel, typeObj);
        var rels = {link: []};

        for (var i = 0; i < relsToAdd.length; i++) {
            rels.link.push({href: self + "/" + relsToAdd[i].href, rel: "" + relsToAdd[i].rel});
        }
        translationLayer.addRels(rels, typeObj);
    }

    /////
    // Internal function for loginAgentSession
    ///
    function getInitialAgentSessionData(reqObj) {
        // Building a clean requestObject, then retrieving the agentSessionUrl from it and store it the the sessionStorage for PageReload support
        var requestObj = translationLayer.buildRequestObj({
            rel: 'location',
            type: 'agent',
            needAuth: true,
            requestType: 'GET'
        });
        sessionDataManager.setSessionData(lpSessionVars.agent, requestObj.url);

        // Building a new request object with the proper query params to retrieve the chat sessions from the server
        requestObj = translationLayer.buildRequestObj({
            rel: 'location',
            type: 'agent',
            needAuth: true,
            requestType: 'GET',
            queryParams: {data: true, cs: 1}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getInitialAgentSessionData - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Initial Agent Session Data"
            });
            if (data && (data.responseCode === 200)) {
                var publishedData = {
                    status: 'loggedIn',
                    chatAvailability: data.body.agentSessionId.info.availability.chat,
                    chatReasonId: data.body.agentSessionId.info.availability.chatReasonId,
                    lpNumber: config.lpNumber,
                    inResume: inResume
                };
                continuityChatSessions = data.body.agentSessionId.chatSessions;
                translationLayer.addRels({link: data.body.agentSessionId.link}, {type: 'agent'});
                addPrivateRels('self', {type: 'agent', ignoreParameters: true}, [
                    {href: "preDefinedContent", rel: "pre-defined-content"}
                ]);
                addPrivateRels('self', {type: 'agent', ignoreParameters: true}, [
                    {href: "chat", rel: "aggregated-chats"}
                ]);
                addPrivateRels('self', {type: 'agent', ignoreParameters: true}, [
                    {href: "visits/visit", rel: "aggregated-visits"}
                ]);
                addPrivateRels('self', {type: 'agent', ignoreParameters: true}, [
                    {href: "collab", rel: "collab-otp"}
                ]);
                addPrivateRels('self', {type: 'agent', ignoreParameters: true}, [
                    {href: "otk", rel: "otk"}
                ]);
                engine.publish({eventName: 'onLogInAgent', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on get Initial Agent Session Data"
            });
            errorData = getErrorData(errorData, 'error logging in agent', reqObj, {status: 'loggedOff'});
            engine.publish({eventName: 'onLogInAgent', data: errorData});
            engine.publish({eventName: 'onLogOutAgent', data: getLoggedOffData(errorData)});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: {},
            sentRequest: requestObj,
            logMessage: "Get Agent Session Data was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    }

    function getAgentSessionData(reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'location',
            type: 'agent',
            needAuth: true,
            requestType: 'GET',
            queryParams: {data: true, bust: Date.now()}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getAgentSessionData - unable to find rel for request'}, "", "", "");
        }

        _setCache(requestObj);

        requestObj.retries =  0;
        requestObj.timeout = lpConnectionTimeout;
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Agent Session Data"
            });
            publishIncomingRequestSuccess(data.body.agentSessionId["incoming-requests"]);
            publishAgentInfoSuccess(data.body.agentSessionId.info);
            runSuccessCallback(reqObj, data.body.agentSessionId);
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on get Agent Session Data"
            });
            errorData = getErrorData(errorData, 'error logging in agent', reqObj, {
                status: 'loggedOff',
                responseCode: errorData.responseCode
            });
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: {},
            sentRequest: requestObj,
            logMessage: "Get Agent Session Data was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    }

    // This function will resume the chat sessions if the agent moved form other device
    function keepContinuityForChats() {
        var resumedChatsCounter = 0;
        var chatRelsFromServerArray = getChatRelsArrayFromServer(continuityChatSessions);
        var chatRelsFromStorageArray = getChatsArrayFromStorage();
        continuityChatSessions = null;

        sessionDataManager.removeSessionData(lpSessionVars.chat);

        if (chatRelsFromServerArray.length || chatRelsFromStorageArray.length) {
            chatRelsFromServerArray = mergeArraysToUnique(chatRelsFromStorageArray, chatRelsFromServerArray);
            //We're reverting the Array in order to maintain the engagements order in the get requests
            chatRelsFromServerArray.reverse();
        }

        getChatSession(chatRelsFromServerArray);

        function getChatsArrayFromStorage() {
            var chatRelsFromStorage = sessionDataManager.getSessionData(lpSessionVars.chat);
            return chatRelsFromStorage ? chatRelsFromStorage.split(separator) : [];
        }

        function getChatRelsArrayFromServer(chatSessions) {
            var chatRelsFromServer = [];
            if (chatSessions && chatSessions.chatSession) {
                chatSessions = chatSessions.chatSession.constructor === Array ? chatSessions.chatSession : [chatSessions.chatSession];
                for (var i = 0; i < chatSessions.length; i++) {
                    chatRelsFromServer.push(chatSessions[i].link['@href']);
                }
            }
            return chatRelsFromServer;
        }

        function mergeArraysToUnique(mainArray, secondaryArray) {
            if (mainArray.length === 0) {
                return secondaryArray;
            }
            if (secondaryArray.length === 0) {
                return mainArray;
            }

            var uniqueArray = mainArray.concat();
            for (var i = 0, j = 0; i < secondaryArray.length; i++) {
                for (; j < uniqueArray.length; j++) {
                    if (uniqueArray[j].indexOf(secondaryArray[i]) >= 0) {
                        break;
                    }
                }
                if (uniqueArray.length === j) {
                    uniqueArray.push(secondaryArray[i]);
                }
            }
            return uniqueArray;
        }

        function getChatSession(chatRelsArray) {
            var chatRel = chatRelsArray.pop();
            if (chatRel) {
                translationLayer.addRels({
                    link: [
                        {rel: 'location', href: chatRel}
                    ]
                }, {type: 'chat', id: 'chatStartRel'});

                getChatSessionData({success: chatResumeSuccess, error: chatResumeError});
            } else {
                engine.publish({eventName: 'onChatsResumed', data: {chatsResumedCount: resumedChatsCounter}});
                if (inResume) {
                    engine.publish({eventName: 'onAgentResumed', data: {chatsResumed: true}});
                }
            }
        }

        function chatResumeSuccess() {
            resumedChatsCounter++;
            getChatSession(chatRelsFromServerArray);
        }

        function chatResumeError() {
            getChatSession(chatRelsFromServerArray);
        }
    }

    agent.sessionEnded = function (agentLogout) {
        logic.setKeepAlive(false);
        if (agentLogout) {
            agent.logOutAgent();
        }
        logic.sessionEnded();
    };

    /////
    // @return  success : {
    //              status: 'loggedOff'
    //          }
    // @return  fail : {
    //              message: 'failed to log off'
    //          }
    ///
    agent.logOutAgent = function (reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'location',
            type: 'agent',
            needAuth: true,
            requestType: 'DELETE'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'onLogOutAgent - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Succes on logOutAgent"
            });
            if (data && (data.responseCode === 200)) {
                var publishedData = {status: 'loggedOff'};
                translationLayer.addRels(data, {type: 'agent'});
                engine.publish({eventName: 'onLogOutAgent', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on logOutAgent"
            });
            logic.setKeepAlive(true);
            setTimeout(logic.keepAlive, 0);
            errorData = getErrorData(errorData, 'error logging off', reqObj);
            engine.publish({eventName: 'onLogOutAgent', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: {}, sentRequest: requestObj, logMessage: "LogOutAgent was sent"});
        logic.stopKeepAlive();
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @param   reqObj : {
    //              chatAvailability : Online | Away | Occupied
    //          }
    // @return  data : {
    //              chatAvailability : Online | Away | Occupied
    //          }
    ///
    agent.setAvailability = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatAvailability) {
            return logAndReturnError({error: 'No chat availability state was passed'}, reqObj, "", "");
        }
        if (!(reqObj.chatAvailability === "Online" || reqObj.chatAvailability === "Away" || reqObj.chatAvailability === "Occupied")) {
            return logAndReturnError({error: 'Chat Availability state incorrect, must be of type : Online | Away | Occupied'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'availability', type: 'agent', needAuth: true,
            requestType: 'PUT', data: {availability: {chat: reqObj.chatAvailability, chatReasonId: reqObj.chatReasonId}}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'setAvailability - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Set Availability"
            });
            if (data) {
                var publishedData = {chatAvailability: reqObj.chatAvailability, chatReasonId: reqObj.chatReasonId};
                engine.publish({eventName: 'onSetAvailability', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Set Availability"
            });
            errorData = getErrorData(errorData, 'Failed to set availability', reqObj, {chatAvailability: 'Offline'});
            engine.publish({eventName: 'onSetAvailability', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Set Availability was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @return  data : {
    //              chatAvailability : Online | Away | Occupied
    //          }
    ///
    agent.getAvailability = function (reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'availability',
            type: 'agent',
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getAvailability - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Availability"
            });
            if (data) {
                var publishedData = {chatAvailability: data.body.availability.chat};
                engine.publish({eventName: 'onAvailability', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on get Availability"
            });
            errorData = getErrorData(errorData, 'getAvailability error on callback', reqObj);
            engine.publish({eventName: 'onAvailability', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: {}, sentRequest: requestObj, logMessage: "Get Availability was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    /**
     *
     * @return data : { preDefinedContent {
     *                          skills: []
     *                          items: [{}]
     *
     * }
     */
    agent.getPreDefinedContent = function (reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'pre-defined-content',
            type: 'agent',
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getPreDefinedContent - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Pre-Defined Content"
            });
            if (data) {
                var preDefinedContent = [];

                if (data && data.body && data.body.preDefinedContent) {
                    preDefinedContent = data.body.preDefinedContent.contentGroup.constructor == Array ? data.body.preDefinedContent.contentGroup : [data.body.preDefinedContent.contentGroup];
                }

                var publishedData = {preDefinedContent: preDefinedContent};
                engine.publish({eventName: 'onPreDefinedContent', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Pre-Defined Content"
            });
            errorData = getErrorData(errorData, 'getPreDefinedContent error on callback', reqObj);
            engine.publish({eventName: 'onPreDefinedContent', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.INFO, {
            originalRequest: {},
            sentRequest: requestObj,
            logMessage: "Get Pre-Defined Content was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @return  data : {
    //              agentName : agent name,
    //              displayName : agent display name,
    //              loginName : agent login name,
    //              agentId : agent id,
    //              maxChats : -1,
    //              availability : {
    //                          chat : Away
    //              }
    //          }
    ///
    agent.getAgentInfo = function (reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'info',
            type: 'agent',
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getAgentInfo - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Agent Info"
            });
            delete data.body.info.link; //Make sure we don't publish rels
            if (data) {
                var publishedData = publishAgentInfoSuccess(data.body.info);
                runSuccessCallback(reqObj, publishedData);
                publishedData = null;
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Agent Info"
            });
            errorData = getErrorData(errorData, 'getAgentInfo error in callback', reqObj);
            engine.publish({eventName: 'onAgentInfo', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: {}, sentRequest: requestObj, logMessage: "Get Agent Info was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    function publishAgentInfoSuccess(data) {
        var publishedData = data;
        publishedData.chatAvailability = publishedData.availability.chat;
        delete publishedData.availability;
        engine.publish({eventName: 'onAgentInfo', data: publishedData});
        logic.setAgentInfo(publishedData);
        return publishedData;
    }

    function getPropFromError(errorData, prop) {
        if (errorData) {
            if (errorData.error) {
                return errorData.error[prop] || "";
            } else {
                if (errorData.body && errorData.body.error) {
                    return errorData.body.error[prop] || "";
                }
            }
        }
        return 0;
    }

    /////
    // @return  data : {
    //              ringingCount : number of incoming chats
    //          }
    ///
    function getIncomingRequests(reqObj) {
        var timestamp = new Date().getTime(); // TODO: might consider removing this after com layer integrates a stricter randomness algorithm.
        var requestObj = translationLayer.buildRequestObj({
            rel: 'incoming-requests',
            type: 'agent',
            needAuth: true,
            requestType: 'GET',
            queryParams: {timestamp: timestamp}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getIncomingRequests - unable to find rel for request'}, "", "", "");
        }
        requestObj.retries = 0;
        requestObj.timeout = lpConnectionTimeout;
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Incoming Requests"
            });
            var publishedData;
            if (data) {
                publishedData = publishIncomingRequestSuccess(data.body.incomingRequests);
            }
            runSuccessCallback(reqObj, publishedData);
            data = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                sentRequest: requestObj,
                response: errorData,
                originalRequest: "ERROR on Get Incoming Requests"
            });
            errorData = getErrorData(errorData, 'getIncomingRequests - server error', null);
            engine.publish({eventName: 'onIncomingRequests', data: errorData});
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Incoming Requests was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    }

    function publishIncomingRequestSuccess(data) {
        updateConnectionState(lpConnectionStates.active);
        var ringingCount = parseInt(data.ringingCount, 10);
        var publishedData = {ringingCount: ringingCount};
        engine.publish({eventName: 'onIncomingRequests', data: publishedData});
        return publishedData;
    }

    ////
    //    {
    //        filterParams : {
    //            skill : skill-id,
    //            chatState : 1,
    //            voiceState : 4
    //        },
    //        agents : [
    //            {
    //                @chatState : "1",
    //                @voiceState : "4",
    //                @maxChats : "-1",
    //                @id : agent-id,
    //                email : email address,
    //                nickname : nickname,
    //                privilegeGroup : group,
    //                skills : {
    //                    skill : [skill-id-1, skill-id-2,...]
    //                },
    //                userName : username,
    //                chats : number of active chats
    //            },
    //            {...}
    //        ]
    //    }
    ///
    agent.getAvailableAgents = function (reqObj) {
        reqObj = reqObj || {};
        if (reqObj.next && (reqObj.skill || reqObj.chatState || reqObj.voiceState)) {
            return logAndReturnError({error: 'getAvailableAgents - Unable to get next available agents with filter'});
        }

        var queryParameters = {};
        if (reqObj.skill) {
            queryParameters.skill = reqObj.skill;
        } // No mandatory fields, adding only if exists.
        if (reqObj.chatState) {
            queryParameters.chatState = reqObj.chatState;
        }
        if (reqObj.voiceState) {
            queryParameters.voiceState = reqObj.voiceState;
        }

        var relName = "available-agents";
        if (reqObj.next && translationLayer.hasRel("available-agents-next", {type: 'agent'})) {
            relName = "available-agents-next";
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: relName,
            needAuth: true,
            type: 'agent',
            method: 'GET',
            queryParams: queryParameters
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getAvailableAgents - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.timeout = 60000; //Might be a long response

        requestObj.success = function (data) {
            if (data) {
                log(logTypes.DEBUG, {
                    originalRequest: reqObj,
                    sentRequest: requestObj,
                    response: data,
                    logMessage: "Success on Get Available Agents"
                });
                var agentsData = [];
                var responseData = {};
                if (data && data.body && data.body.availableAgents && data.body.availableAgents.agents) {
                    agentsData = data.body.availableAgents.agents.agent.constructor === Array ? data.body.availableAgents.agents.agent : [data.body.availableAgents.agents.agent];

                    if (data.body.availableAgents.link && data.body.availableAgents.link['@rel'] === "next") {
                        data.body.availableAgents.link['@rel'] = "available-agents-next";
                    }
                    if (reqObj.skill || reqObj.chatState || reqObj.voiceState) {
                        responseData.filterParams = queryParameters;
                    }
                    responseData.agents = agentsData;
                }
                translationLayer.addRels(data.body.availableAgents, {type: 'agent'});
                engine.publish({eventName: 'onAvailableAgents', data: responseData});
                runSuccessCallback(reqObj, responseData);
            }
            requestObj = null;
        };

        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Available Agents"
            });
            errorData = getErrorData(errorData, 'getAvailableAgents - server error', reqObj);
            engine.publish({eventName: 'onAvailableAgents', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Available Agents was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @return  data : {
    //              visitorInfo : {
    //                  visitorId : 1,
    //                  visitorName : visitor,
    //                  visitorTyping : visitor typing status
    //              },
    //              chatInfo : {
    //                  chatId : chat id,
    //                  events : events object,
    //                  startTime : 12:00,
    //                  lastUpdate : 12:00,
    //                  state : chat state
    //              },
    //              agentInfo : {
    //                  agentName : agent name,
    //                  agentTyping : agent typing status
    //              }
    //          }
    ///
    agent.acceptChat = function (reqObj) { //No parameters passed here
        var requestObj = translationLayer.buildRequestObj({
            rel: 'incoming-requests',
            type: 'agent',
            needAuth: true,
            requestType: 'POST'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'acceptChat - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Accept Chat"
            });
            if (data && (data.responseCode === 201)) {
                translationLayer.addRels(data.body.chatLocation, {type: 'chat', id: 'chatStartRel'}); //Hack, we add a temp rel since we are running in synch to the next method
                getChatSessionData(reqObj);
            }
            reqObj = null;
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Accept Chat"
            });
            errorData = getErrorData(errorData, 'getAvailableAgents - server error', reqObj);
            engine.publish({eventName: 'onAcceptChat', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: {}, sentRequest: requestObj, logMessage: "Accept Chat was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // Internal function for acceptChat
    // Gets passed the previous reqObj in case there were direct callbacks specified for success and errr handling
    ///
    function getChatSessionData(reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'location', type: 'chat', id: 'chatStartRel', needAuth: true,
            requestType: 'GET'
        });
        var uri = requestObj.url;
        translationLayer.removeRels({type: 'chat', id: 'chatStartRel'}); //Cleanup the data we input just to start the chat session
        if (!requestObj) {
            return logAndReturnError({error: 'getChatSessionData - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            if (data) {
                var publishData = {};
                if (data.body && data.body.chat) {
                    logic.addChatEventsRequestToQueue(data.body.chat.info.rtSessionId, data.body.chat.info.chatSessionKey, data.body.chat.info.visitorId, data.body.chat.events.event.length, uri, true);
                    log(logTypes.DEBUG, {data: "ACCEPT CHAT GOT DATA chat info, id: " + data.body.chat.info.rtSessionId + " visitorId: " + data.body.chat.info.visitorId});
                    logic.fixVisitorId(data.body.chat.info);
                    translationLayer.addRels(data.body.chat, {
                        type: 'chat',
                        id: data.body.chat.info.rtSessionId,
                        data: {visitor: data.body.chat.info.visitorId}
                    }); //TODO This is a bit more complex, we have chat, info (visitor supposedly)
                    translationLayer.addRels(data.body.chat.info, {type: 'visitor', id: data.body.chat.info.visitorId});
                    publishData.visitorInfo = {
                        visitorId: data.body.chat.info.visitorId,
                        appServerVisitorId: data.body.chat.info.appServerVisitorId,
                        visitorName: data.body.chat.info.visitorName,
                        visitorTyping: (data.body.chat.info.visitorTyping === 'typing'),
                        shark: data.body.chat.info.shark,
                        sessionId: data.body.chat.info.sharkSessionId,
                        lang: data.body.chat.info.language,
                        engagementId: data.body.chat.info.engagementId,
                        campaignId: data.body.chat.info.campaignId,
                        participantId: data.body.chat.info.participantId,
                        skillName: data.body.chat.info.skillName || ""
                    };
                    data.body.chat.events.link = null;
                    delete data.body.chat.events.link; //Make sure we don't publish rels
                    publishData.chatInfo = {
                        chatId: data.body.chat.info.rtSessionId,
                        events: data.body.chat.events,
                        startTime: data.body.chat.info.startTime,
                        lastUpdate: data.body.chat.info.lastUpdate,
                        skillIds: data.body.chat.info.skillId,
                        skillName: data.body.chat.info.skillName || "",
                        chatSessionId: data.body.chat.info.chatSessionKey || ""
                    };
                    if (data.body.chat.info.state) { // TODO: AGENTS-1538 - this is a fix to "after HW restart no chat state" bug, can be reverted to previous state once appServer 15.7.2 is live
                        publishData.chatInfo.state = data.body.chat.info.state;
                    }
                    publishData.agentInfo = {
                        agentName: data.body.chat.info.agentName,
                        agentTyping: data.body.chat.info.agentTyping,
                        agentId: data.body.chat.info.agentId
                    };
                    processChat(data.body.chat);
                }
                engine.publish({eventName: 'onAcceptChat', data: publishData});
                runSuccessCallback(reqObj, publishData);
                publishData = null;
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: {},
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Chat Session Data"
            });
            errorData = getErrorData(errorData, 'onAcceptChat - server error', reqObj);
            engine.publish({eventName: 'onAcceptChat', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: {},
            sentRequest: requestObj,
            logMessage: "Get Chat Session Data was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    }

    /////
    // Create an otk for the current Agent Session
    //
    agent.createAgentSessionOTK = function (reqObj) {
        var requestObj = translationLayer.buildRequestObj({
            rel: 'otk',
            type: 'agent',
            needAuth: true,
            requestType: 'POST'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'otk - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.INFO, {
                originalRequest: {},
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Create Agent Session OTK"
            });
            if (data && data.body && data.body.otk) {
                runSuccessCallback(reqObj, data.body);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Create Agent Session OTK"
            });
            errorData = getErrorData(errorData, 'otk - error on callback', reqObj);
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: {},
            sentRequest: requestObj,
            logMessage: "Create Agent Session OTK was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    chat.startSpectate = function (reqObj) {
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'startSpectate - invalid chat id'}, "", "", "");
        }
        var requestObj = {};
        requestObj.chatId = reqObj.chatId;
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {data: "startSpectate got chat info, chat id: " + reqObj.chatId + " visitor id: " + data.chat.info.visitorId});
            engine.publish({eventName: "onStartSpectate", data: data});
            runSuccessCallback(reqObj, data);
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {data: "startSpectate got error on chat info, chat id: " + reqObj.chatId});
            engine.publish({eventName: "onStartSpectate", data: errorData});
            runErrorCallback(reqObj, errorData);
        };
        getChatsData(requestObj);
    };

    chat.pauseSpectate = function (reqObj) {
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'pauseSpectate - invalid chat id'}, "", "", "");
        }
        logic.updateChatSession(reqObj.chatId); // Added one last call to this resource to make sure the inactive chat will be as updated as possible
        if (logic.stopChatPolling(reqObj.chatId)) {
            runSuccessCallback(reqObj);
        } else {
            runErrorCallback(reqObj);
        }
        engine.publish({eventName: "onPauseSpectate"});
    };

    chat.resumeSpectate = function (reqObj) {
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'resumeSpectate - invalid chat id'}, "", "", "");
        }
        if (logic.resumeChatPolling(reqObj.chatId)) {
            runSuccessCallback(reqObj);
        } else {
            runErrorCallback(reqObj);
        }
        engine.publish({eventName: "onResumeSpectate"});
    };

    chat.stopSpectate = function (reqObj) {
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'stopSpectate - invalid chat id'}, "", "", "");
        }
        logic.removeChatFromQueue(reqObj.chatId);
        logic.clearChatData(reqObj.chatId);
        engine.publish({eventName: "onStopSpectate"});
    };

    chat.openSpectated = function (reqObj) {
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'openSpectated - invalid chat id'}, "", "", "");
        }
        var data = {
            visitorInfo: {
                visitorId: reqObj.visitorId,
                shark: reqObj.shark
            },
            chatInfo: {
                chatId: reqObj.chatId
            }
        };
        engine.publish({eventName: "onOpenSpectated", data: data});
    };



    /////
    // @param   reqObj : {
    //              skill : alphanumeric,
    //              maxWaitTime: int (between 0 & 86400)
    //              agent: agentLoginName
    //          }
    // @return  success : {
    //              estimatedWaitTime: 0,
    //          }
    // @return  fail : {
    //              error: 'Unable to get wait time'
    // }
    ///
    chat.getChatAvailableSlots = function (reqObj) {
        var queryParams = {};
        if (reqObj) {
            if (reqObj.skill && typeof reqObj.skill === 'string') {
                queryParams.skill = reqObj.skill;
            }
            if (reqObj.maxWaitTime && typeof reqObj.maxWaitTime === 'number') {
                queryParams.maxWaitTime = reqObj.maxWaitTime;
            }
            if (reqObj.agent && typeof reqObj.agent === 'string' && !reqObj.skill) {
                queryParams.agent = reqObj.agent;
            }//Only valid if no skill was selected
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'chat-available-slots',
            type: 'agent',
            needAuth: true,
            requestType: 'GET',
            queryParams: queryParams
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getChatAvailableSlots - unable to find rel for request'}, "", "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: (reqObj || ''),
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Chat Available Slots"
            });
            if (data && data.body && data.body.availableSlots) {
                var publishedData = {chatAvailableSlots: data.body.availableSlots};
                engine.publish({eventName: 'onChatAvailableSlots', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: '',
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Chat Available Slots"
            });
            errorData = getErrorData(errorData, 'getChatAvailableSlots - server error', reqObj);
            engine.publish({eventName: 'onChatAvailableSlots', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: (reqObj || ''),
            sentRequest: requestObj,
            logMessage: "Get Chat Available Slots was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @param   reqObj : {
    //              chatId : 1,
    //              skillId || agentId : 1
    //              text : "I think this person need some help from a you." (optional)
    //          }
    // @return  success : {
    //              chatId : 1
    //          }
    ///
    chat.transferChat = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, reqObj, "", "");
        }
        if (!reqObj.chatId || isNaN(reqObj.chatId)) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        if ((!reqObj.skillId || isNaN(reqObj.skillId)) && (!reqObj.agentId || isNaN(reqObj.agentId))) {
            return logAndReturnError({error: 'No/Invalid skillId/agentId was submitted'}, reqObj, "", "");
        }
        var transferData = {transfer: {}};
        if (reqObj.skillId) {
            transferData.transfer.skill = {id: reqObj.skillId};
        } else {
            transferData.transfer.agent = {id: reqObj.agentId};
        }
        if (reqObj.text) {
            transferData.transfer.text = reqObj.text;
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'transfer',
            type: 'chat',
            id: reqObj.chatId,
            needAuth: true,
            requestType: 'POST',
            data: transferData
        });
        if (!requestObj) {
            return logAndReturnError({error: 'transferChat - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Transfer Chat"
            });
            if (data) {
                var publishedData = {chatId: reqObj.chatId};
                engine.publish({eventName: 'onTransferChat', data: publishedData});
                engine.publish({
                    eventName: 'onChatState',
                    appName: reqObj.chatId,
                    data: createChatStateObj(reqObj.chatId, "transferred", new Date().toUTCString())
                });
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Transfer Chat"
            });
            errorData = getErrorData(errorData, 'transferChat  - server error', reqObj);
            engine.publish({eventName: 'onTransferChat', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEbug, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "Transfer Chat was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @param   reqObj : {
    //              chatId : 1
    //          }
    // @return  data : {
    //              chatId : 1
    //              skills : skills object
    //          }
    ///
    chat.getAvailableSkills = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId || isNaN(reqObj.chatId)) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        var buildInfo = {rel: 'transfer', type: 'chat', id: reqObj.chatId, needAuth: true, requestType: 'GET'};
        //        if(reqObj.state === "online" || reqObj.state === "offline" || reqObj.state === "all" || reqObj.state === "away"){
        //            buildInfo.queryParams = { state: reqObj.state };
        //        }
        var requestObj = translationLayer.buildRequestObj(buildInfo);
        if (!requestObj) {
            return logAndReturnError({error: 'getAvailableSkills - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.timeout = 60000; //Might be a long response
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Available Skills"
            });
            if (data) {
                if (data.body.transfer.skill) {
                    data.body.transfer.skill = data.body.transfer.skill.constructor === Array ? data.body.transfer.skill : [data.body.transfer.skill];
                }
                var publishedData = {skills: data.body.transfer, chatId: reqObj.chatId};
                engine.publish({eventName: 'onAvailableSkills', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Available Skills"
            });
            errorData = getErrorData(errorData, 'getAvailableSkills - server error', reqObj);
            engine.publish({eventName: 'onAvailableSkills', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Available Skills was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @param   reqObj : {
    //              chatId : 1
    //          }
    // @return  data : {
    //              chatId : 1
    //              skills : skills object
    //          }
    ///
    chat.getAvailableRemoteAccounts = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId || isNaN(reqObj.chatId)) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        var buildInfo = {rel: 'transfer-account', type: 'chat', id: reqObj.chatId, needAuth: true, requestType: 'GET'};

        var requestObj = translationLayer.buildRequestObj(buildInfo);
        if (!requestObj) {
            return logAndReturnError({error: 'getAvailableRemoteAccounts - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Available Remote Accounts"
            });
            if (data) {
                var publishedData = {chatId: reqObj.chatId};
                if (data.body.transferAccount.hasVirtualSkills) {
                    publishedData.availableRemoteAccounts = data.body.transferAccount.remoteAccount;
                }
                engine.publish({eventName: 'onAvailableRemoteAccounts', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Available Remote Accounts"
            });
            errorData = getErrorData(errorData, 'getAvailableSkills - server error', reqObj);
            engine.publish({eventName: 'onAvailableRemoteAccounts', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Available Accounts was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    /////
    // @param   reqObj : {
    //              chatId : 1
    //          }
    // @return  data : {
    //              chatId : 1
    //              skills : skills object
    //          }
    ///
    chat.transferChatToRemoteAccount = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId || isNaN(reqObj.chatId)) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        var buildInfo = {
            rel: 'transfer-account',
            type: 'chat',
            id: reqObj.chatId,
            needAuth: true,
            requestType: 'POST',
            data: {transferAccount: {skillId: reqObj.skillId, text: reqObj.text}}
        };

        var requestObj = translationLayer.buildRequestObj(buildInfo);
        if (!requestObj) {
            return logAndReturnError({error: 'transferChatToRemoteAccount - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on transferring the chat to remote account"
            });
            if (data) {
                var publishedData = {chatId: reqObj.chatId};
                engine.publish({eventName: 'onTransferChatToRemoteAccount', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: "",
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on transferring the chat to remote account"
            });
            errorData = getErrorData(errorData, 'onTransferAccount - server error', reqObj);
            engine.publish({eventName: 'onTransferChatToRemoteAccount', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Transfer account was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    function filterEventsByTypeAndChannel(eventsData) {
        if (!eventsData.event) {
            return null;
        }
        eventsData = eventsData.event;
        eventsData = eventsData.constructor === Array ? eventsData : [eventsData];
        var eventsRes = {};
        var gotEvents = false;
        for (var i = 0; i < eventsData.length; i++) {
            var type = eventsData[i].type || eventsData[i]['@type'];
            if (eventsData[i].channelID) {
                var channelId = eventsData[i].channelID;
                eventsRes[type] = eventsRes[type] || {};
                eventsRes[type][channelId] = eventsRes[type][channelId] || [];
                eventsRes[type][channelId].push(eventsData[i]);
            } else {
                eventsRes[type] = eventsRes[type] || [];
                eventsRes[type].push(eventsData[i]);
            }
            gotEvents = true;
        }
        eventsRes.lastEventId = gotEvents ? eventsData[eventsData.length - 1].id || eventsData[eventsData.length - 1]["@id"] : 0;
        return (!gotEvents ? null : eventsRes);
    }

    function getChatsData(reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatSessionKeys && !reqObj.chatId) {
            return logAndReturnError({error: 'No/Invalid query params was submitted'}, reqObj, "", "");
        }
        var reqQueryParam = {};
        if (reqObj.chatSessionKeys) {
            reqQueryParam.chatSessionKeys = reqObj.chatSessionKeys;
        }
        if (reqObj.fromEventIds) {
            reqQueryParam.fromEventIds = reqObj.fromEventIds;
        }
        if (reqObj.chatId) {
            reqQueryParam.rtSessionId = reqObj.chatId;
        }

        var requestObj = translationLayer.buildRequestObj({
            rel: 'aggregated-chats', type: 'agent', needAuth: true, requestType: 'GET',
            queryParams: reqQueryParam
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getChatsData - unable to find rel for request'}, reqObj, "", "");
        }
        _setCache(requestObj);
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Chats Data"
            });
            if (data && data.body && data.body.chats) {
                var chatsData = data.body.chats.chat.constructor === Array ? data.body.chats.chat : [data.body.chats.chat];
                var publishedData = data;
                for (var index = 0; index < chatsData.length; index++) {
                    if (typeof(reqObj.chatId) !== 'undefined') { // startSpectate flow
                        publishedData = {chat: chatsData[index]};
                        var url = chatsData[index].link[0].href;
                        logic.addChatEventsRequestToQueue(chatsData[index].info.rtSessionId, chatsData[index].info.chatSessionKey, chatsData[index].info.visitorId, chatsData[index].events.event.length, url, false);
                    }
                    processChat(chatsData[index]); // aggregatedChats flow
                }
                runSuccessCallback(reqObj, publishedData);
                publishedData = null;
                chatsData = null;
                data = null;
                reqObj = null;
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Chats Data"
            });
            errorData = getErrorData(errorData, 'getChatsData - server error', reqObj);
            engine.publish({eventName: 'onChatEvents', data: errorData});
            runErrorCallback(reqObj, errorData);
            errorData = null;
            reqObj = null;
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "Get Chats Data was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    }

    function processChat(chat) {
        var chatId;
        if (chat && chat.error) {
            chatId = logic.getChatIdBySessionKey(chat.error.chatSessionKey);
            engine.publish({
                eventName: 'onChatState',
                appName: chatId,
                data: createChatStateObj(chatId, "ended", new Date().toUTCString())
            });
        } else if (chat && chat.info) {
            chatId = chat.info.rtSessionId;
            logic.fixVisitorId(chat.info);
            translationLayer.addRels(chat, {type: 'chat', id: chatId});
            translationLayer.addRels(chat.info, {type: 'visitor', id: chat.info.visitorId});
            chat.link = null;
            delete chat.link;
            if (logic.isActiveChat(chatId)) {
                processChatEvents(chat);
                processChatInfo(chat);
            }
        }
    }

    function processChatEvents(chat) {
        if (chat && chat.info && chat.info.rtSessionId && chat.events) {
            chat.events.link = null;
            delete chat.events.link;
            var chatId = chat.info.rtSessionId;
            var eventsBreakDown = filterEventsByTypeAndChannel(chat.events);

            if (eventsBreakDown) {//if we have any events
                logic.setLastEventId(chatId, eventsBreakDown.lastEventId);

                chat.info.stateData = {state: chat.info.state};
                handleBreakDownEvents();

                engine.publish({
                    eventName: 'onChatEvents',
                    appName: chatId,
                    data: {
                        chatInfo: {
                            chatId: chatId,
                            events: chat.events,
                            lastUpdate: chat.info.lastUpdate
                        },
                        visitorInfo: {
                            visitorId: chat.info.visitorId
                        }
                    }
                });
            }
            eventsBreakDown = null;
        }

        function handleBreakDownEvents() {
            var chatLines = [];

            for (var eventType in eventsBreakDown) {
                if (eventsBreakDown.hasOwnProperty(eventType)) {
                    switch (eventType) {
                        case 'line':
                            addToChatLineQueue(eventsBreakDown[eventType]);
                            break;

                        case 'state':
                            handleStateEvents(eventsBreakDown[eventType]);
                            break;

                        case 'leCollaboration':
                            normalizeCollaborationEvent(eventsBreakDown[eventType]);
                            extendCollaborationChatBaseData(eventsBreakDown[eventType]);
                            handleLeCollaborationEvents(eventsBreakDown[eventType]);
                            addToChatLineQueue(eventsBreakDown[eventType]);
                            break;
                    }
                }
            }

            if (chatLines && chatLines.length) {
                chatLines = chatLines.sort(function (a, b) {
                    var idA = a.id || a['@id'];
                    var idB = b.id || b['@id'];
                    return (+idA > +idB) ? 1 : -1;
                });

                publishChatLines(chatLines);
            }

            function publishChatLines(events) {
                if (events) {
                    var publishData = {
                        eventName: 'onChatLine',
                        appName: chatId,
                        data: {lines: events, visitorId: chat.info.visitorId, chatId: chatId}
                    };
                    engine.publish(publishData);
                }
            }

            // Aggregate all the chat events (leSecureForms & chatLines) into one bucket.
            function addToChatLineQueue(events) {
                if (events) {
                    events = events.constructor === Array ? events : [events];
                }
                chatLines = chatLines.concat(events);
            }

            function handleStateEvents(events) {
                if (events) { // We got a chat state event
                    chat.info.stateData.time = events[events.length - 1].time;
                }
            }

            function handleLeCollaborationEvents(events) {
                var publishData = {
                    eventName: 'onCollaborationEvent',
                    appName: chatId,
                    data: {events: events, visitorId: chat.info.visitorId, chatId: chatId}
                };
                engine.publish(publishData);
            }

            function normalizeCollaborationEvent(events) {
                for (var i = 0; i < events.length; i++) {
                    var event = events[i];
                    if (event.hasOwnProperty('info')) {
                        var args = {};
                        for (var j = 0; j < event.info.length; j++) {
                            var nameProp = event.info[j]['@name'] || event.info[j].name;

                            if (nameProp === 'secureFormName'){
                                args[nameProp] = SecureUtilities.escapeForHtmlContent(event.info[j].$);
                            } else {
                                args[nameProp] = event.info[j].$;
                            }
                        }
                        event.args = args;
                    }
                }
            }

            function extendCollaborationChatBaseData(events) {

                function getTranslation(key, args){
                    return agentLEManager.translateLE({key: 'LEWebAgent.' + key, args: args});
                }

                for (var i = 0; i < events.length; i++) {
                    var event = events[i];
                    switch (event.command) {

                        case lpSecureFormsController.EVENT_TYPES.SEND:
                            event.text = getTranslation('secure_form_send_event_text', [{
                                isTranslate: false,
                                key: event.by
                            }, {isTranslate: false, key: event.args.secureFormName}]);
                            break;
                        case lpSecureFormsController.EVENT_TYPES.RECEIVED:
                            event.text = getTranslation('secure_form_received_event_text', [{
                                isTranslate: false,
                                key: event.args.secureFormName
                            }]);
                            break;
                        case lpSecureFormsController.EVENT_TYPES.VIEWED:
                            if(event.source === 'agent'){
                                event.text = getTranslation('secure_form_agent_viewed_event_text', [{
                                    isTranslate: false,
                                    key: event.args.secureFormName
                                }]);
                            }else{
                                event.text = getTranslation('secure_form_viewed_event_text', [{
                                    isTranslate: false,
                                    key: event.args.secureFormName
                                }]);
                            }
                            break;
                        case lpSecureFormsController.EVENT_TYPES.ERROR:
                            // > ONLY FROM THE VISITOR SIDE
                            event.text = getTranslation('secure_form_error_event_text', [{
                                isTranslate: false,
                                key: event.args.secureFormName
                            }]);
                            break;
                        case lpSecureFormsController.EVENT_TYPES.ABORTED:
                            event.text = getTranslation('secure_form_aborted_event_text', [{
                                isTranslate: false,
                                key: event.args.secureFormName
                            }]);
                            break;
                        case lpSecureFormsController.EVENT_TYPES.SUBMIT:
                            event.text = getTranslation('secure_form_submit_event_text', [{
                                isTranslate: false,
                                key: event.args.secureFormName
                            }]);
                            break;
                    }

                }
            }
        }
    }

    function processChatInfo(chat) {
        var chatId = chat.info.rtSessionId;
        chat.info.link = null;
        delete chat.info.link;
        var publishData = {
            chatInfo: {
                chatId: chatId,
                startTime: chat.info.startTime,
                skillIds: chat.info.skillId
            },
            visitorInfo: {
                visitorId: chat.info.visitorId,
                visitorName: chat.info.visitorName,
                visitorTyping: (chat.info.visitorTyping === 'typing'),
                shark: chat.info.shark,
                sessionId: chat.info.sharkSessionId,
                engagementId: chat.info.engagementId,
                campaignId: chat.info.campaignId,
                participantId: chat.info.participantId,
                skillName: chat.info.skillName || '',
                lang: chat.info.language
            }
        };
        if (chat.info.agentId) {
            publishData.agentInfo = {
                agentName: chat.info.agentName,
                agentTyping: (chat.info.agentTyping === 'typing'),
                agentId: chat.info.agentId
            };
        }
        engine.publish({eventName: 'onChatInfo', appName: chatId, data: publishData});
        // In case a HA restart is performed. the chat resource returns without states in the events list.
        // Due to that, we send the state with undefined timestamp, the UI should know how to handle this.
        if (chat.info.stateData) {
            engine.publish({
                eventName: 'onChatState',
                appName: chatId,
                data: createChatStateObj(chatId, chat.info.stateData.state, chat.info.stateData.time)
            });
        }
    }

    /////
    // @param   reqObj : {
    //              chatId : 1,
    //              text : 'hello',
    //              textType: 'html/url/plain'
    //          }
    // @return  success : {
    //              chatId: 1,
    //              source : 'agent',
    //              textType: type,
    //              text: text,
    //              time: addLine time
    //          }
    // @return  fail : {
    //              error: reason for failure
    //          }
    ///
    chat.addLine = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        var lineType = reqObj.textType || 'plain';
        var isTextual = lineType === 'html' || lineType === 'url' || lineType === 'plain';
        var isStructured = lineType === 'rich-content';
        var isTextTypeValid = lineType && (isTextual || isStructured);
        if (!isTextTypeValid) {
            return logAndReturnError({error: 'Unknown Text type: ' + lineType}, reqObj, "", "");
        }
        if (isTextual && !reqObj.text) {
            return logAndReturnError({error: 'No text to send'}, reqObj, "", "");
        }
        if (isStructured && !reqObj.json) {
            return logAndReturnError({error: 'No json to send'}, reqObj, "", "");
        }
        if (!reqObj.chatId || !logic.isActiveChat(reqObj.chatId)) {
            return logAndReturnError({error: 'No chatId or inactive chat'}, reqObj, "", "");
        }
        var dateTime = new Date();
        var requestData = {event: {'@type': 'line', textType: lineType, cannedResponse:reqObj.cannedResponse}};
        if (isTextual) {
            requestData.event.text = reqObj.text;
        } else if (isStructured) {
            requestData.event.json = reqObj.json;
            if (reqObj.metadata) {
                requestData.event.metadata = reqObj.metadata;
            }
        }
        if (reqObj.subType) {
            requestData.event.subType = reqObj.subType;
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'events', id: reqObj.chatId,
            needAuth: true, type: 'chat', requestType: 'POST', data: requestData
        });
        if (!requestObj) {
            return logAndReturnError({error: 'addLine - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Add Line"
            });
            if (data) {
                var publishedData = {
                    chatId: reqObj.chatId,
                    source: 'agent',
                    textType: lineType,
                    text: reqObj.text,
                    time: dateTime,
                    id: extractLineIdFromResponse(data)
                };
                engine.publish({eventName: 'onAddLine', data: publishedData}); // TODO validate response content
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Add Line"
            });
            errorData = getErrorData(errorData, 'addLine  - server error', reqObj);
            engine.publish({eventName: 'onAddLine', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "Add Line was sent"});
        return LpAjaxTransport.issueCall(requestObj);

        function extractLineIdFromResponse(resp){
            if(resp && resp.responseCode === 201){
                var respLink = resp && resp.body && resp.body.chatEventLocation && resp.body.chatEventLocation.link && resp.body.chatEventLocation.link['@href'];
                if(typeof respLink === 'string'){
                    var linkParts = respLink.split('/');
                    if(linkParts.length > 0){
                        return linkParts.pop();
                    }
                }
            }
        }
    };

    /* ***************************************************************************************** */

    /////
    // @param   reqObj : {
    //              chatId : 1,
    //              uniqueId: 'text',
    //              subType: 'secureForm',
    //              command: 'send/read/...',
    //              text : 'hello',
    //              textType: 'html/url/plain'
    //          }
    // @return  success : {
    //          }
    // @return  fail : {
    //              error: reason for failure
    //          }
    ///
    chat.sendCollaborationEvent = function (reqObj) {
        // Asserts:
        if (!reqObj.chatId || !logic.isActiveChat(reqObj.chatId)) {
            return logAndReturnError({error: 'No chatId or inactive chat'}, reqObj, "", "");
        }

        //if(!reqObj.uniqueId){
        //    return logAndReturnError({error: 'No unique id'}, reqObj, "", "");
        //}

        if (!reqObj.subType) {
            return logAndReturnError({error: 'No sub type'}, reqObj, "", "");
        }

        if (!reqObj.command) {
            return logAndReturnError({error: 'No command'}, reqObj, "", "");
        }

        // TODO: error for Args property.

        // Building the request data
        var dateTime = new Date();
        var requestData = createRequestData();
        var requestObj = translationLayer.buildRequestObj({
            rel: 'events', id: reqObj.chatId,
            needAuth: true, type: 'chat', requestType: 'POST', data: requestData
        });

        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on send collaboration event"
            });
            if (data) {
                var publishedData = {chatId: reqObj.chatId, time: dateTime, data: requestData.event};
                engine.publish({eventName: 'onSendCollaborationEvent', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on send collaboration event"
            });
            errorData = getErrorData(errorData, 'onSendCollaborationEvent  - server error', reqObj);
            engine.publish({eventName: 'onSendCollaborationEvent', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "collaboration event was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);

        function createRequestData() {
            return {
                event: {
                    '@type': 'leCollaboration',
                    'subType': reqObj.subType,
                    'command': reqObj.command,
                    by: reqObj.by,
                    source: reqObj.source,
                    info: convertArgsToServerInfo(reqObj.args)
                }
            };

            function convertArgsToServerInfo() {
                var info = [];
                if (reqObj.args) {
                    for (var key in reqObj.args) {
                        if (reqObj.args.hasOwnProperty(key)) {
                            info.push({
                                '@name': key,
                                '$': reqObj.args[key]
                            });
                        }
                    }
                }
                return info;
            }

        }

    };

    chat.requestOTKForCollaboration = function (reqObj) {

        if (!reqObj.chatId || !logic.isActiveChat(reqObj.chatId)) {
            return logAndReturnError({error: 'No chatId or inactive chat'}, reqObj, "", "");
        }

        if (!reqObj.args && reqObj.uniqueId) {
            return logAndReturnError({error: 'No unique id'}, reqObj, "", "");
        }

        // Building the request data
        var dateTime = new Date();
        var requestObj = translationLayer.buildRequestObj({
            rel: 'self', id: reqObj.chatId,
            needAuth: true, type: 'chat', requestType: 'GET',
            queryParams: {UUID: reqObj.uuid}
        });

        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on requesting collaboration OTK"
            });
            if (data) {
                var publishedData = {
                    chatId: reqObj.chatId,
                    otk: getOTKFromResponse(),
                    expiration: null,
                    time: dateTime
                };
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
            function getOTKFromResponse() {
                return data && data.body && data.body.agentOtk && data.body.agentOtk.otk;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on requesting collaboration OTK "
            });
            errorData = getErrorData(errorData, 'requestOTKForCollaboration  - server error', reqObj);
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "collaboration otk request was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);


    };

    /* ***************************************************************************************** */

    /////
    // @param   reqObj : {
    //              chatId : 1
    //          }
    // @return  data : {
    //              chatId : 1,
    //              state : ended
    //          }
    ///
    chat.endChat = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'events', type: 'chat', id: reqObj.chatId,
            needAuth: true, requestType: 'POST', data: {"event": {"@type": "state", "state": "ended"}}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'endChat - unable to find rel for request'}, reqObj, "", "");
        }
        var dateTime = new Date();
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on End Chat"
            });
            if (data) {
                var publishedData = createChatStateObj(reqObj.chatId, 'ended', dateTime.toUTCString());
                engine.publish({eventName: 'onEndChat', appName: reqObj.chatId, data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on End Chat"
            });
            errorData = getErrorData(errorData, 'endChat - server error', reqObj);
            engine.publish({eventName: 'onEndChat', appName: reqObj.chatId, data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "End Chat was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    function createChatStateObj(chatId, state, time) {
        return {chatId: chatId, state: state, time: time};
    }

    /////
    // @param   reqObj : {
    //              chatId : 1,
    //              typing : true/false
    //          }
    // @return  data : {
    //              chatId : 1,
    //              typing : true/false
    //          }
    ///
    chat.setAgentTyping = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        if (reqObj.typing === undefined || reqObj.typing.constructor !== Boolean) {
            return logAndReturnError({error: 'No/Invalid typing state was submitted'}, reqObj, "", "");
        }
        if (logic.getAgentTypingStatus(reqObj.chatId) === reqObj.typing) {//Typing status hasn't changed so we cancel request
            var publishedData = {typing: (reqObj.typing && reqObj.typing === true), chatId: reqObj.chatId};
            runSuccessCallback(reqObj, publishedData);
            return;
        }
        logic.setAgentTyping(reqObj.chatId, reqObj.typing);
        var typingStatus = reqObj.typing && reqObj.typing === true ? 'typing' : 'not-typing';
        var requestObj = translationLayer.buildRequestObj({
            rel: 'agent-typing',
            id: reqObj.chatId,
            needAuth: true,
            type: 'chat',
            requestType: 'PUT',
            data: {agentTyping: typingStatus}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'setAgentTyping - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Set Agent Typing"
            });
            if (data) {
                var publishedData = {typing: (reqObj.typing && reqObj.typing === true), chatId: reqObj.chatId};
                engine.publish({eventName: 'onAgentTyping', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Set Agent Typing"
            });
            errorData = getErrorData(errorData, 'setAgentTyping - server error', reqObj);
            engine.publish({eventName: 'onAgentTyping', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Set Agent Typing was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    //
    //  @param  reqObj : {
    //              chatId : 1
    //          }
    //
    //  @return data : {
    //              chatId : 1,
    //              survey : {
    //                  header : ""
    //                  id : survey id
    //                  title : survey title
    //                  questions : {
    //                      question : [{
    //                              id : question id
    //                              label : question label
    //                              lastKnownValue :  ""
    //                              logicId : 1
    //                              mandatory : false
    //                              order : 0
    //                              type : Text Field
    //                              validationType : alpha_numeric
    //                      },{ ... }]
    //                  }
    //              }
    //          }
    chat.getAgentSurvey = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        var buildReqObj = {
            rel : 'agent-survey',
            type : 'chat',
            id : reqObj.chatId,
            needAuth : true,
            requestType : 'GET'
        };
        buildReqObj.queryParams = {windowSurveyEnabled: reqObj.windowSurveyEnabled};
        if(reqObj.surveyApiId){
            buildReqObj.queryParams.surveyApiId = reqObj.surveyApiId;
        }
        if(reqObj.engSkillId){
            buildReqObj.queryParams.engSkillId = reqObj.engSkillId;
        }
        var requestObj = translationLayer.buildRequestObj(buildReqObj);
        if (!requestObj) {
            return logAndReturnError({error: 'getAgentSurvey - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Agent Survey"
            });
            if (data) {
                var publishedData = {chatId: reqObj.chatId, survey: data.body.survey};
                engine.publish({eventName: 'onAgentSurvey', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            var isRealError = true;
            if (errorData && errorData.body && errorData.body.error) {
                if(errorData.body.error.message === "Survey is inactive") {
                    log(logTypes.INFO, {message: "Survey is inactive"});
                    isRealError = false;
                } else if(errorData.body.error.internalCode === SURVEY_NOT_FOUND_ERR_CODE) {
                    log(logTypes.INFO, {message: "Missing survey"});
                    isRealError = false;
                }
            }

            if(isRealError) {
                log(logTypes.ERROR, {
                    originalRequest: reqObj,
                    sentRequest: requestObj,
                    response: errorData,
                    logMessage: "ERROR on Get Agent Survey"
                });
            }
            errorData = getErrorData(errorData, 'getAgentSurvey - server error', reqObj);
            engine.publish({eventName: 'onAgentSurvey', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Agent Survey was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    //
    //  @param  reqObj : {
    //              chatId : 1 ,
    //              survey : {
    //                  id : survey-id ,
    //                  question : [ { id : question-id, answer : [answer1,answer2...] } , {...} , ... ]
    //              }
    //          }
    //
    chat.setAgentSurvey = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId) {
            return logAndReturnError({error: 'No/Invalid chat-id was submitted'}, reqObj, "", "");
        }
        if (!reqObj.survey) {
            return logAndReturnError({error: 'No Survey data submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'agent-survey',
            id: reqObj.chatId,
            needAuth: true,
            type: 'chat',
            requestType: 'PUT',
            data: {survey: reqObj.survey}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'setAgentSurvey - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Set Agent Survey"
            });
            if (data) {
                var publishedData = {chatId: reqObj.chatId};
                engine.publish({eventName: 'onSetAgentSurvey', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
            }
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Set Agent Survey"
            });
            errorData = getErrorData(errorData, 'getAgentSurvey - server error', reqObj);
            engine.publish({eventName: 'onSetAgentSurvey', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };

        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Set Agent Survey was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    chat.chatCompleted = function (chatId) {
        if (!chatId) {
            return false;
        }
        logic.removeChatFromQueue(chatId);
        return logic.clearChatData(chatId);
    };
    /////
    // @param   reqObj : {
    //              visitorId : 108001
    //          }
    // @return  data : {
    //              visitorId : 108001
    //              pages : [ {
    //                      @id : page id,
    //                      @index : page index
    //                      @isCurrent : true
    //                      time : page time
    //                      title : page title
    //                      url : page url
    //                  },
    //                  {...} ]
    //          }
    ///
    participant.getVisitSessionPages = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.visitorId) {
            return logAndReturnError({error: 'No/Invalid visitor Id was submitted'}, "", "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'pages',
            type: 'visitor',
            id: reqObj.visitorId,
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getVisitSessionPages - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.INFO, {originalRequest: reqObj, sentRequest: requestObj, response: data});
            if (data) {
                var publishedData = {
                    visitorId: reqObj.visitorId,
                    pages: getVisitSessionPagesFromObj(data, reqObj.visitorId)
                };
                engine.publish({eventName: 'onVisitSessionPages', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {originalRequest: reqObj, sentRequest: requestObj, response: errorData});
            errorData = getErrorData(errorData, 'getVisitSessionPages - server error', reqObj);
            engine.publish({eventName: 'onVisitSessionPages', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.INFO, {originalRequest: reqObj, sentRequest: requestObj, response: "SENDING REQUEST"});
        return LpAjaxTransport.issueCall(requestObj);
    };

    function getVisitSessionPagesFromObj(dataObj, visitorId) {
        var pages = dataObj && dataObj.pages && dataObj.pages.page ? dataObj.pages.page : [];
        visitorId = dataObj && dataObj.visitInfo && dataObj.visitInfo.visitorId ? dataObj.visitInfo.visitorId : visitorId;
        pages = pages.constructor === Array ? pages : [pages];
        logic.setLastPageIndex(visitorId, getLastPageIndex(dataObj));
        return pages;
    }

    function getVisitURIs(reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.visitSessionKeys || !reqObj.fromPageIndexes) {
            return "Missing visit session keys or pages indexes for request";
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'aggregated-visits',
            type: 'agent',
            needAuth: true,
            requestType: 'GET',
            queryParams: reqObj
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getVisitURIs - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Visit URIs"
            });
            if (data && data.body && data.body.visitIds && data.body.visitIds.visitId) {
                var visitsData = data.body.visitIds.visitId.constructor === Array ? data.body.visitIds.visitId : [data.body.visitIds.visitId];
                for (var i = 0; i < visitsData.length; i++) {
                    processVisitInformation(visitsData[i], visitsData[i].visitInfo.visitorId);
                }
                visitsData = null;
                data = null;
                reqObj = null;
                requestObj = null;
            }
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Visit URIs"
            });
            errorData = getErrorData(errorData, 'getVisitURIs - server error', reqObj);
            engine.publish({eventName: 'onVisitURIs', data: errorData});
            errorData = null;
            reqObj = null;
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "Get Visit URIs was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    }

    /////
    // private function for retrieving Visit URI
    /////
    function getVisitURI(reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.chatId || !reqObj.visitorId) {
            return logAndReturnError({error: 'Missing chatId and/or visitorId'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'visit-id', type: 'chat', id: reqObj.chatId, needAuth: true,
            requestType: 'GET', queryParams: {data: true}
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getVisitURI - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Visit URI"
            });
            translationLayer.addRels(data, {type: 'visitor', id: reqObj.visitorId});
            if (data) {
                data.body.visitId.visitInfo.visitorId = reqObj.visitorId; //TODO: this is done since we identified a bug in the REST API's, sometimes we get a different visitor ID from the visit-id resource comparing to the visitor ID we get from the chat-session-resource.
                processVisitInformation(data.body.visitId, reqObj.visitorId);
                runSuccessCallback(reqObj, data);
            }
            data = null;
            requestObj = null;
        };
        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "Success on Get Visit URI"
            });
            errorData = getErrorData(errorData, 'onGetVisitorInfo - server error', reqObj);
            engine.publish({eventName: 'onGetVisitURI', data: errorData});
            errorData = null;
            requestObj = null;
        };
        log(logTypes.DEBUG, {originalRequest: reqObj, sentRequest: requestObj, logMessage: "Get Visit URI was sent"});
        return LpAjaxTransport.issueCall(requestObj);
    }

    function processVisitInformation(visit, visitorId) {
        if (visit.error && visit.error.visitSessionKey) {
            log(logTypes.WARN, {errorObj: visit.error});
        } else {
            engine.publish({
                eventName: 'onCustomVariables',
                data: {
                    visitorId: visitorId,
                    customVars: getCustomVariablesFromObj(visit),
                    visitSessionKey: visit.visitSessionKey
                }
            });
            engine.publish({
                eventName: 'onVisitSessionPages',
                data: {
                    visitorId: visitorId,
                    pages: getVisitSessionPagesFromObj(visit),
                    visitSessionKey: visit.visitSessionKey
                }
            });
            engine.publish({
                eventName: 'onVisitSessionDetails',
                data: {
                    visitorId: visitorId,
                    sessionDetails: getVisitSessionDetailsFromObj(visit),
                    visitSessionKey: visit.visitSessionKey
                }
            });
            engine.publish({
                eventName: 'onOperatorAlerts',
                data: {
                    visitorId: visitorId,
                    operatorAlerts: getOperatorAlertsFromObj(visit),
                    visitSessionKey: visit.visitSessionKey
                }
            });
        }
    }

    function getLastPageIndex(data) {
        if (data.pages && data.pages.page) {
            var pageArray = data.pages.page.constructor == Array ? data.pages.page : [data.pages.page];
            var lastPageIndex = pageArray[pageArray.length - 1]["@index"] || pageArray[pageArray.length - 1].index;
            lastPageIndex = parseInt(lastPageIndex, 10);
            lastPageIndex = lastPageIndex !== -1 ? lastPageIndex : pageArray.length - 1;
            pageArray = null;
            return lastPageIndex;
        }
    }

    /////
    // @param   reqObj : {
    //              visitorId : 108001
    //          }
    // @return  data : {
    //              customVars : object containing all custom variables
    //          }
    ///
    participant.getCustomVariables = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.visitorId) {
            return logAndReturnError({error: 'No/Invalid visitor Id was submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'custom-variables',
            type: 'visitor',
            id: reqObj.visitorId,
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getCustomVariables - unable to find rel for request'}, reqObj, "", "");
        }

        _setCache(reqObj);
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Custom Variables"
            });
            if (data) {
                var publishedData = {visitorId: reqObj.visitorId, customVars: getCustomVariablesFromObj(data.body)};
                engine.publish({eventName: 'onCustomVariables', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };

        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Custom Variables"
            });
            errorData = getErrorData(errorData, 'getCustomVariables - server error', reqObj);
            engine.publish({eventName: 'onCustomVariables', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Custom Variables was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    function getCustomVariablesFromObj(dataObj) {
        if (dataObj.customVariables && dataObj.customVariables.link) {
            dataObj.customVariables.link = null;
            delete dataObj.customVariables.link;
            return dataObj.customVariables;
        }
    }

    /////
    // @param   reqObj : {
    //              visitorId : 108001
    //          }
    // @return  data : {
    //              sessionDetails : object containing session details
    //          }
    ///
    participant.getVisitSessionDetails = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.visitorId) {
            return logAndReturnError({error: 'No/Invalid visitor Id was submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'info',
            type: 'visitor',
            id: reqObj.visitorId,
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getVisitSessionDetails - unable to find rel for request'}, reqObj, "", "");
        }
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Visit Session Details"
            });
            if (data) {
                var publishedData = {
                    visitorId: reqObj.visitorId,
                    sessionDetails: getVisitSessionDetailsFromObj(data.body)
                };
                engine.publish({eventName: 'onVisitSessionDetails', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };

        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Visit Session Details"
            });
            errorData = getErrorData(errorData, 'getVisitSessionDetails - server error', reqObj);
            engine.publish({eventName: 'onVisitSessionDetails', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Visit Session Details was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    function getVisitSessionDetailsFromObj(dataObj) {
        var visitInfo = {};
        if (dataObj && dataObj.visitInfo) {
            if (dataObj.visitInfo.link) {
                dataObj.visitInfo.link = null;
                delete dataObj.visitInfo.link;
            }
            visitInfo = dataObj.visitInfo;
            if (visitInfo.sessionInfo && visitInfo.sessionInfo.info) {
                addVisitStartTimeToInfoArray(visitInfo.sessionInfo.info, dataObj);
            }
        }
        return visitInfo;

        function addVisitStartTimeToInfoArray(infoArray, dataObj) {
            var visitStartTime;
            if (dataObj.visitInfo.time && dataObj.visitInfo.time.info) {
                visitStartTime = dataObj.visitInfo.time.info;
            }
            infoArray.push(visitStartTime);
        }
    }

    participant.getChatHistory = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.visitorId) {
            return logAndReturnError({error: 'No/Invalid visitor Id was submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'chat-history',
            type: 'visitor',
            id: reqObj.visitorId,
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getChatHistory - unable to find rel for request'}, reqObj, "", "");
        }

        _setCache(reqObj);
        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "Success on Get Chat History"
            });
            if (data) {
                var publishedData = {visitorId: reqObj.visitorId, chatHistory: data.body.chatHistory};
                engine.publish({eventName: 'onChatHistory', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };

        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get Chat History"
            });
            errorData = getErrorData(errorData, 'getChatHistory - server error', reqObj);
            errorData.visitorId = reqObj.visitorId;
            engine.publish({eventName: 'onChatHistory', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get Chat History was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    participant.getOperatorAlerts = function (reqObj) {
        if (!reqObj) {
            return logAndReturnError({error: 'No object data passed'}, "", "", "");
        }
        if (!reqObj.visitorId) {
            return logAndReturnError({error: 'No/Invalid visitor Id was submitted'}, reqObj, "", "");
        }
        var requestObj = translationLayer.buildRequestObj({
            rel: 'operator-alerts',
            type: 'visitor',
            id: reqObj.visitorId,
            needAuth: true,
            requestType: 'GET'
        });
        if (!requestObj) {
            return logAndReturnError({error: 'getOperatorAlerts - unable to find rel for request'}, reqObj, "", "");
        }

        _setCache(reqObj);

        requestObj.success = function (data) {
            log(logTypes.DEBUG, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: data,
                logMessage: "SUCCESS on Get operator alerts"
            });
            if (data) {
                var publishedData = {visitorId: reqObj.visitorId, operatorAlerts: getOperatorAlertsFromObj(data.body)};
                engine.publish({eventName: 'onOperatorAlerts', data: publishedData});
                runSuccessCallback(reqObj, publishedData);
                requestObj = null;
            }
        };

        requestObj.error = function (errorData) {
            log(logTypes.ERROR, {
                originalRequest: reqObj,
                sentRequest: requestObj,
                response: errorData,
                logMessage: "ERROR on Get operator alerts"
            });
            errorData = getErrorData(errorData, 'getOperatorAlerts - server error', reqObj);
            errorData.visitorId = reqObj.visitorId;
            engine.publish({eventName: 'onOperatorAlerts', data: errorData});
            runErrorCallback(reqObj, errorData);
            requestObj = null;
        };
        log(logTypes.DEBUG, {
            originalRequest: reqObj,
            sentRequest: requestObj,
            logMessage: "Get operator alerts was sent"
        });
        return LpAjaxTransport.issueCall(requestObj);
    };

    function getOperatorAlertsFromObj(dataObj) {
        if (dataObj && dataObj.operatorAlerts) {
            if (dataObj.operatorAlerts.link) {
                dataObj.operatorAlerts.link = null;
                delete dataObj.operatorAlerts.link;
            }
            if (dataObj.operatorAlerts.operatorAlert) {
                return dataObj.operatorAlerts.operatorAlert.constructor == Array ? dataObj.operatorAlerts.operatorAlert : [dataObj.operatorAlerts.operatorAlert];
            } else {
                return null;
            }
        }
    }

    participant.disposeParticipant = function (visitorId) {
        return translationLayer.removeRels({type: 'visitor', id: visitorId});
    };

    ///////////EVENTS///////////
    agent.onLoad = function (callBack, appName, context) {
        return addToEventEngine('onLoad', callBack, appName || '', context);
    };
    agent.onInit = function (callBack, appName, context) {
        return addToEventEngine('onInit', callBack, appName || '', context);
    };
    agent.onLogInAgent = function (callBack, appName, context) {
        return addToEventEngine('onLogInAgent', callBack, appName || '', context);
    };
    agent.onSetAvailability = function (callBack, appName, context) {
        return addToEventEngine('onSetAvailability', callBack, appName || '', context);
    };
    agent.onAvailability = function (callBack, appName, context) {
        return addToEventEngine('onAvailability', callBack, appName || '', context);
    };
    agent.onIncomingRequests = function (callBack, appName, context) {
        return addToEventEngine('onIncomingRequests', callBack, appName || '', context);
    };
    agent.onLogOutAgent = function (callBack, appName, context) {
        return addToEventEngine('onLogOutAgent', callBack, appName || '', context);
    };
    agent.onAgentInfo = function (callBack, appName, context) {
        return addToEventEngine('onAgentInfo', callBack, appName || '', context);
    };
    agent.onLog = function (callBack, appName, context) {
        return addToEventEngine('onLog', callBack, appName || '', context);
    };
    agent.onConnectionState = function (callBack, appName, context) {
        return addToEventEngine('onConnectionState', callBack, appName || '', context);
    };
    agent.onAvailableAgents = function (callBack, appName, context) {
        return addToEventEngine('onAvailableAgents', callBack, appName || '', context);
    };
    agent.onPreDefinedContent = function (callBack, appName, context) {
        return addToEventEngine('onPreDefinedContent', callBack, appName || '', context);
    };
    agent.onAcceptChat = function (callBack, appName, context) {
        return addToEventEngine('onAcceptChat', callBack, appName || '', context);
    };
    agent.onAgentResumed = function (callBack, appName, context) {
        return addToEventEngine('onAgentResumed', callBack, appName || '', context);
    };
    agent.onChatsResumed = function (callBack, appName, context) {
        return addToEventEngine('onChatsResumed', callBack, appName || '', context);
    };
    chat.onStartSpectate = function (callBack, appName, context) {
        return addToEventEngine('onStartSpectate', callBack, appName || '', context);
    };
    chat.onPauseSpectate = function (callBack, appName, context) {
        return addToEventEngine('onPauseSpectate', callBack, appName || '', context);
    };
    chat.onResumeSpectate = function (callBack, appName, context) {
        return addToEventEngine('onResumeSpectate', callBack, appName || '', context);
    };
    chat.onStopSpectate = function (callBack, appName, context) {
        return addToEventEngine('onStopSpectate', callBack, appName || '', context);
    };
    chat.onOpenSpectated = function (callBack, appName, context) {
        return addToEventEngine('onOpenSpectated', callBack, appName || '', context);
    };
    chat.onTransferChat = function (callBack, appName, context) {
        return addToEventEngine('onTransferChat', callBack, appName || '', context);
    };
    chat.onTransferChatToRemoteAccount = function (callBack, appName, context) {
        return addToEventEngine('onTransferChatToRemoteAccount', callBack, appName || '', context);
    };
    chat.onAvailableSkills = function (callBack, appName, context) {
        return addToEventEngine('onAvailableSkills', callBack, appName || '', context);
    };
    chat.onAvailableRemoteAccounts = function (callBack, appName, context) {
        return addToEventEngine('onAvailableRemoteAccounts', callBack, appName || '', context);
    };
    chat.onChatEvents = function (callBack, appName, context) {
        return addToEventEngine('onChatEvents', callBack, appName || '', context);
    };
    chat.onChatLine = function (callBack, appName, context) {
        return addToEventEngine('onChatLine', callBack, appName || '', context);
    };
    chat.onChatInfo = function (callBack, appName, context) {
        return addToEventEngine('onChatInfo', callBack, appName || '', context);
    };
    chat.onChatState = function (callBack, appName, context) {
        return addToEventEngine('onChatState', callBack, appName || '', context);
    };
    chat.onAddLine = function (callBack, appName, context) {
        return addToEventEngine('onAddLine', callBack, appName || '', context);
    };
    chat.onSetAgentTyping = function (callBack, appName, context) {
        return addToEventEngine('onSetAgentTyping', callBack, appName || '', context);
    };
    chat.onEndChat = function (callBack, appName, context) {
        return addToEventEngine('onEndChat', callBack, appName || '', context);
    };
    chat.onAgentSurvey = function (callBack, appName, context) {
        return addToEventEngine('onAgentSurvey', callBack, appName || '', context);
    };
    chat.onSetAgentSurvey = function (callBack, appName, context) {
        return addToEventEngine('onSetAgentSurvey', callBack, appName || '', context);
    };

    chat.onChatAvailableSlots = function (callBack, appName, context) {
        return addToEventEngine('onChatAvailableSlots', callBack, appName || '', context);
    };
    chat.onCollaborationEvent = function (callBack, appName, context) {
        return addToEventEngine('onCollaborationEvent', callBack, appName || '', context);
    };
    chat.onSendCollaborationEvent = function (callBack, appName, context) {
        return addToEventEngine('onSendCollaborationEvent', callBack, appName || '', context);
    };
    participant.onCustomVariables = function (callBack, appName, context) {
        return addToEventEngine('onCustomVariables', callBack, appName || '', context);
    };
    participant.onVisitSessionKey = function (callBack, appName, context) {
        return addToEventEngine('onVisitSessionKey', callBack, appName || '', context);
    };
    participant.onVisitSessionPages = function (callBack, appName, context) {
        return addToEventEngine('onVisitSessionPages', callBack, appName || '', context);
    };
    participant.onVisitSessionDetails = function (callBack, appName, context) {
        return addToEventEngine('onVisitSessionDetails', callBack, appName || '', context);
    };
    participant.onChatHistory = function (callBack, appName, context) {
        return addToEventEngine('onChatHistory', callBack, appName || '', context);
    };
    participant.onOperatorAlerts = function (callBack, appName, context) {
        return addToEventEngine('onOperatorAlerts', callBack, appName || '', context);
    };
    //Unbind function can unbound according to function, context or appName
    agent.unbind = function (eventName, appName, callback, context) {
        return unbindFromEvents(eventName, appName, callback, context);
    };
    //Allow facades to unbind as well
    chat.unbind = participant.unbind = agent.unbind;

    createInstanceVariables();


    return {
        agent: lpTag.agent,
        chat: lpTag.chat,
        voice: lpTag.voice,
        participant: lpTag.participant,
        sessionDataManager: sessionDataManager
    };

});
